import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { useCallback, useEffect, useState, useRef } from 'react';
import { Icon, InputWithIcon, SelectMenu, toast, CONSTANTS, BasicTooltip, ExpandedTooltip } from '@livable/saas-react-components';
import { Tab, Tabs, TextField, MenuItem, Button, Chip, Grid, Typography, ToggleButtonGroup, ToggleButton, Skeleton, FormGroup, FormControlLabel, Switch, IconButton, LinearProgress } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { SmartNav } from 'src/components/shared/SmartNav';
import { BigWarningAlert } from 'src/components/general/BigAlerts';
import { PortfolioActionsMenu } from 'src/components/shared/PortfolioActionsMenu';
import { PropertyActionsMenu } from 'src/components/shared/PropertyActionsMenu';
import { SimpleConfirmationModal } from 'src/components/shared/SimpleConfirmationModal';
import BillingTab from './billingTab';
import { CompaniesSelector } from './CompaniesSelectorComponent';
import { ResidentsTabContent } from './ResidentsTabContent';
import { DetailedItem } from './detailedItem';
import { PropertiesListView } from './PropertiesListView';
import { observer } from 'mobx-react-lite';
import { useStore } from 'src/stores';
import { toJS } from 'mobx';
import { Link as RouterLink } from 'react-router-dom';
import { capitalizeFirstLetter } from 'src/utils/capitalizeFirstLetter';
import { FEE_UNIT_TYPES } from 'src/constants/feesSetting';
import { RESIDENCY_STATUS_KEY_VALUES } from 'src/constants/residency';
import { PAYMENT_METHODS } from 'src/constants/payments';
import { PROPERTY_STATUS_ENUM } from 'src/constants/property';
import moment from 'moment';
import DOMPurify from 'dompurify';
import useStyles from './styles';
import welcomeToLivable from 'src/img/welcomeToLivable.svg';
import { AppfolioBatches } from './AppfolioBatches';
import { PropertyAddPage } from '../PropertyAddPage';
import { ALLOCATION_METHOD } from 'src/constants/utilities';
import { PortfoliosList } from './PortfoliosList';
import { PortfoliosMenu } from './PortfoliosMenu';
import resumeFolder from 'src/img/resumeFolder.svg';
import { PropertyPortfolioTagsBlock } from 'src/components/shared/PropertyPortfolioTagsBlock';
import { AssignPropertiesToPortfolioModal } from './AssignPropertiesToPortfolioModal';
import { AssignPortfoliosToPropertyModal } from './AssignPortfoliosToPropertieModal';
import { DetailedStreetFinder } from 'src/components/general/DetailedStreetFinder';
import { parseJwt } from 'src/core/services/jwt';
import { AUTH_TOKEN_KEYS } from 'src/constants/authToken';
export const NewBillingModuleContent = observer(_ref => {
  var _store$homeDashboardS, _store$homeDashboardS2, _store$homeDashboardS3, _store$homeDashboardS11, _store$homeDashboardS23, _store$homeDashboardS24, _store$homeDashboardS36, _store$homeDashboardS37, _store$homeDashboardS38, _store$homeDashboardS39, _store$homeDashboardS40, _store$homeDashboardS41, _store$homeDashboardS42, _store$homeDashboardS43, _store$homeDashboardS45, _store$portfolios$get5, _store$homeDashboardS46, _store$homeDashboardS47, _store$homeDashboardS51, _store$homeDashboardS55, _store$homeDashboardS56, _store$homeDashboardS57, _store$homeDashboardS58, _store$homeDashboardS59, _store$buildings$getB2, _store$homeDashboardS60, _store$homeDashboardS61, _store$homeDashboardS62, _store$homeDashboardS63, _store$homeDashboardS64, _store$homeDashboardS65, _store$homeDashboardS66, _store$homeDashboardS67, _store$homeDashboardS70, _store$homeDashboardS71, _store$homeDashboardS72, _store$homeDashboardS73, _store$homeDashboardS74, _store$homeDashboardS75, _store$homeDashboardS80, _store$homeDashboardS81, _store$homeDashboardS82, _store$homeDashboardS83, _store$homeDashboardS84, _store$homeDashboardS85, _store$homeDashboardS86, _store$homeDashboardS87, _store$homeDashboardS88, _store$homeDashboardS89, _store$homeDashboardS90, _store$homeDashboardS91, _store$properties$get5, _store$portfolios$edi, _store$homeDashboardS96, _store$homeDashboardS97, _store$propertyUtilit7, _store$properties$get6, _store$properties$get7, _store$homeDashboardS98, _store$utilityProvide10, _store$homeDashboardS100, _store$credentials$pa, _store$credentials$pa2, _store$homeDashboardS101, _store$homeDashboardS102, _store$homeDashboardS103, _store$homeDashboardS105, _store$credentials$pa3, _store$credentials$pa4, _store$homeDashboardS106, _store$homeDashboardS107, _store$homeDashboardS108, _store$homeDashboardS110, _store$credentials$pa5, _store$credentials$pa6, _store$homeDashboardS111, _store$homeDashboardS112, _store$homeDashboardS113, _store$homeDashboardS115, _store$credentials$pa7, _store$credentials$pa8, _store$credentials$pa9, _store$homeDashboardS116, _store$homeDashboardS117, _store$homeDashboardS118, _store$homeDashboardS120, _store$credentials$pa0, _store$credentials$pa1, _store$homeDashboardS121, _store$homeDashboardS122, _store$homeDashboardS123, _store$homeDashboardS124, _store$homeDashboardS125, _store$homeDashboardS128, _store$homeDashboardS131, _store$homeDashboardS132, _store$homeDashboardS133, _store$homeDashboardS134, _store$homeDashboardS135, _store$homeDashboardS136, _store$homeDashboardS138, _store$homeDashboardS139, _store$homeDashboardS140, _store$homeDashboardS141, _store$homeDashboardS144, _store$homeDashboardS147, _store$homeDashboardS148, _store$homeDashboardS149, _store$homeDashboardS150, _store$homeDashboardS151, _store$homeDashboardS152, _store$homeDashboardS153, _currentPropertySubsc, _currentPropertySubsc2, _currentPropertySubsc3, _store$units$getUnits, _store$homeDashboardS155, _store$homeDashboardS156, _assignPortfoliosToPr, _assignPortfoliosToPr2, _store$homeDashboardS158, _removePortfolioFromP;
  let handleOpenUnitModal = _ref.handleOpenUnitModal,
    handleOpenPropertyInfoModal = _ref.handleOpenPropertyInfoModal,
    handleOpenUtilityModal = _ref.handleOpenUtilityModal,
    handleOpenAmenityModal = _ref.handleOpenAmenityModal,
    handleOpenFeeSetupModal = _ref.handleOpenFeeSetupModal,
    handleOpenPaymentMethodModal = _ref.handleOpenPaymentMethodModal,
    handleOpenReimbursementModal = _ref.handleOpenReimbursementModal,
    handleShowEnrollModal = _ref.handleShowEnrollModal,
    handleShowManageAccessModal = _ref.handleShowManageAccessModal,
    setIsDeletePortfolioModalOpen = _ref.setIsDeletePortfolioModalOpen,
    setDeleteModalProps = _ref.setDeleteModalProps,
    setIsRenamePortfolioModalOpen = _ref.setIsRenamePortfolioModalOpen,
    setRenameModalProps = _ref.setRenameModalProps,
    handleShowCreateEditPortfolioTrigger = _ref.handleShowCreateEditPortfolioTrigger,
    triggerRefreshPortfolioData = _ref.triggerRefreshPortfolioData,
    handleOpenCreateAccountModal = _ref.handleOpenCreateAccountModal,
    handleOpenContactInformationModal = _ref.handleOpenContactInformationModal,
    fetchPropertyInformation = _ref.fetchPropertyInformation;
  const classes = useStyles();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const store = useStore();
  const navigate = useNavigate();
  const location = useLocation();
  const _useParams = useParams(),
    navPortfolioId = _useParams.navPortfolioId,
    navPropertyId = _useParams.navPropertyId;
  const accessTokenAsync = parseJwt(localStorage.getItem(AUTH_TOKEN_KEYS.accessToken));
  const COMPANY_ID = accessTokenAsync['custom:companyid'];
  const basePath = "/active_dashboard/".concat(COMPANY_ID, "/").concat(navPortfolioId, "/").concat(navPropertyId);
  let currentTab = "".concat(basePath, "/billing");
  if (location.pathname.includes('residents')) {
    currentTab = "".concat(basePath, "/residents");
  } else if (location.pathname.includes('details')) {
    currentTab = "".concat(basePath, "/details");
  } else if (location.pathname.includes('appfolio-batches')) {
    currentTab = "".concat(basePath, "/appfolio-batches");
  }
  const currentPropertyId = (_store$homeDashboardS = store.homeDashboardStore.getCurrentProperty) === null || _store$homeDashboardS === void 0 ? void 0 : _store$homeDashboardS.id;
  const companySubscriptions = store.stripe.subscriptionCompanySubscriptions;
  const currentPropertySubscription = companySubscriptions.find(subscription => {
    var _subscription$scope;
    return ((_subscription$scope = subscription.scope) === null || _subscription$scope === void 0 ? void 0 : _subscription$scope.toLowerCase()) === 'property' && subscription.propertyIds.includes(currentPropertyId);
  }) || companySubscriptions.find(subscription => {
    var _subscription$scope2;
    return ((_subscription$scope2 = subscription.scope) === null || _subscription$scope2 === void 0 ? void 0 : _subscription$scope2.toLowerCase()) === 'account';
  });
  const isPortfoliosDetails = store.homeDashboardStore.selectedPortfolioId !== null && store.homeDashboardStore.selectedPortfolioId !== 'all' && store.homeDashboardStore.selectedPropertyId === 'portfolio_details';
  const isDefaultPortfoliosDetails = (_store$homeDashboardS2 = store.homeDashboardStore.getCurrentPortfolio) === null || _store$homeDashboardS2 === void 0 ? void 0 : _store$homeDashboardS2.isDefault;
  const isNewPortfolioDetails = !((_store$homeDashboardS3 = store.homeDashboardStore.getCurrentPortfolio) !== null && _store$homeDashboardS3 !== void 0 && (_store$homeDashboardS3 = _store$homeDashboardS3.properties) !== null && _store$homeDashboardS3 !== void 0 && _store$homeDashboardS3.length);
  const _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    portfolioDetailsSearchKey = _useState2[0],
    setPortfolioDetailsSearchKey = _useState2[1];
  const _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    showRentGl = _useState4[0],
    setShowRentGl = _useState4[1];
  const backActionRef = useRef(null);
  const nextActionRef = useRef(null);
  const handleTriggerBack = () => {
    if (backActionRef.current) {
      backActionRef.current();
    }
  };
  const handleTriggerNext = () => {
    if (nextActionRef.current) {
      nextActionRef.current();
    }
  };
  const isBackNextActionDisabled = () => {
    return store.units.getUnitsAsync.inProgress || store.units.updateUnitsAsync.inProgress || store.buildings.getBuildingAsync.inProgress || store.inUnitAmenities.getAllInUnitAmenitiesAsync.inProgress || store.properties.getPropertyUtilityProvidersV3Async.inProgress || store.properties.updatePropertySetupProgressAsync.inProgress || store.account.getProfileAsync.inProgress || store.fees.getExistingFeesAsync.inProgress || store.address.addNewAddressAsync.inProgress || store.address.updateAddressAsync.inProgress || store.properties.getPropertyAsync.inProgress || store.address.batchGetAddressesAsync.inProgress || store.properties.updatePropertyAsync.inProgress || store.properties.getPropertyFeesAsync.inProgress || store.properties.createNewPropertyAsync.inProgress || store.properties.getPropertyFeesV2Async.inProgress || store.properties.getPropertysContactsAsync.inProgress || store.portfolios.getExistingPortfoliosAsync.inProgress || store.teamMembers.getCompanyTeamMembersAsync.inProgress || store.properties.getPropertySetupProgressAsync.inProgress || store.portfolios.transferPortfoliosAsync.inProgress || store.utilityProviders.getUtilityProvidersAsync.inProgress || store.account.assignResourceTeamMemberAsync.inProgress || store.portfolios.createPortfolioAsync.inProgress || store.properties.updatePropertyFeesV2Async.inProgress || store.payment.getStripeProductsAsync.inProgress || !store.addNewProperty.feeStructureV2.feesValidation || store.amenities.getAllCommonAreaAmenitiesRawAsync.inProgress || store.properties.addPropertyUtilityProviderAsync.inProgress || store.properties.addPropertyCommonAreaAmenityAsync.inProgress || store.amenities.getAllAmenitiesRawAsync.inProgress || store.utilityProviders.getPropertyCommonAreaAmenitiesAsync.inProgress || store.properties.deletePropertyUtilityProvidersAsync.inProgress || store.utilityProviders.patchPropertyCommonAreaAmenitiesAsync.inProgress || store.propertyUtility.deleteNewPropertyUtilityConfigAsync.inProgress || store.propertyUtility.getPropertyUtilitiesByPropertyAsync.inProgress || store.urjanet.getCompanyCredentialsAsync.inProgress || store.propertyUtility.updateNewPropertyUtilityConfigAsync.inProgress ||
    // These validations belong to the Utilities step only. Gating them on
    // `activeStep === 'utilities'` prevents the user from being trapped
    // (Back/Next both disabled) on unrelated steps when resuming a flow
    // where the utilities store wasn't hydrated (e.g. Appfolio property
    // without a global GL account, so globalGlAccountExternalId stays '').
    store.addNewProperty.activeStep === 'utilities' && (store.company.companyFeatureStore.isAppfolio && !store.addNewProperty.utilitiesSetupV2.globalGlAccountExternalId || store.addNewProperty.utilitiesSetupV2.selectedUtilities.filter(i => i.isEnabled && (ALLOCATION_METHOD.BySquareFootage === i.allocationMethod || ALLOCATION_METHOD.By50Occupancy50SquareFootage === i.allocationMethod) && Number(store.addNewProperty.utilitiesSetupV2.sqFootage) === 0).length !== 0) || store.properties.activatePropertyAsync.inProgress || store.properties.updatePropertysContactsAsync.inProgress || store.payment.getPayoutAchDirectDepositAsync.inProgress || store.payment.postPayoutAchDirectDepositAsync.inProgress || store.payment.putPayoutAchDirectDepositAsync.inProgress || store.payment.getPayoutRegularCheckAsync.inProgress || store.payment.putPayoutRegularCheckAsync.inProgress || store.payment.postPayoutRegularCheckAsync.inProgress || store.payment.getPaymentMethodsAsync.inProgress || store.payment.getPaymentMethodsV2Async.inProgress || store.payment.getPropertyPaymentMethodAsync.inProgress || store.payment.getPublicKeyAsync.inProgress || store.payment.setPropertyPaymentMethodAsync.inProgress || store.payment.getSetupIntentWithSubscriptionAsync.inProgress || store.payment.assignCompanyPayoutMethodToPropertyAsync.inProgress;
  };
  const handleGlSearch = v => {
    var _store$homeDashboardS4;
    (_store$homeDashboardS4 = store.homeDashboardStore.getCurrentCompany.selectedPropertyDetails()) === null || _store$homeDashboardS4 === void 0 || (_store$homeDashboardS4 = _store$homeDashboardS4.details) === null || _store$homeDashboardS4 === void 0 || (_store$homeDashboardS4 = _store$homeDashboardS4.glCodeSetup) === null || _store$homeDashboardS4 === void 0 || _store$homeDashboardS4.searchGlAccounts(v);
  };
  const handleGlSelectClose = () => {
    var _store$homeDashboardS5;
    (_store$homeDashboardS5 = store.homeDashboardStore.getCurrentCompany.selectedPropertyDetails()) === null || _store$homeDashboardS5 === void 0 || (_store$homeDashboardS5 = _store$homeDashboardS5.details) === null || _store$homeDashboardS5 === void 0 || (_store$homeDashboardS5 = _store$homeDashboardS5.glCodeSetup) === null || _store$homeDashboardS5 === void 0 || _store$homeDashboardS5.handleGlSelectClose();
  };
  const handleViewType = (e, newValue) => {
    if (newValue) {
      store.homeDashboardStore.getCurrentCompany.changeCompanyDashboardViewType(newValue);
    }
  };
  const _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    isPaymentMethodSelectOpen = _useState6[0],
    setPaymentMethodSelectOpen = _useState6[1];
  const _useState7 = useState(''),
    _useState8 = _slicedToArray(_useState7, 2),
    paymentMethodSearch = _useState8[0],
    setPaymentMethodSearch = _useState8[1];
  const handleOpenPaymentMethodSelect = () => setPaymentMethodSelectOpen(true);
  const handleClosePaymentMethodSelect = () => setPaymentMethodSelectOpen(false);
  const handlePaymentMethodChange = async event => {
    var _toJS;
    const resp = await store.payment.setPropertyPaymentMethodAsync.run({
      propertyId: (_toJS = toJS(store.homeDashboardStore.getCurrentProperty)) === null || _toJS === void 0 ? void 0 : _toJS.id,
      paymentMethodId: event.target.value
    });
    if (resp && resp.isSuccessful) {
      var _store$homeDashboardS6;
      setPaymentMethodSearch('');
      (_store$homeDashboardS6 = store.homeDashboardStore.getCurrentCompany.selectedPropertyDetails()) === null || _store$homeDashboardS6 === void 0 || _store$homeDashboardS6.details.paymentSetup.setPropertyPaymentMethod(event.target.value);
      toast('success', {
        body: ['Successfully saved']
      });
    }
  };

  // NOTE: START Reimbursement methods section (aka payouts)
  const _useState9 = useState(false),
    _useState0 = _slicedToArray(_useState9, 2),
    isReimbursementSelectOpen = _useState0[0],
    setReimbursementSelectOpen = _useState0[1];
  const _useState1 = useState(''),
    _useState10 = _slicedToArray(_useState1, 2),
    reimbursementMethodSearchKey = _useState10[0],
    setReimbursementMethodSearchKey = _useState10[1];
  const handleOpenReimbursementSelect = () => {
    setReimbursementMethodSearchKey('');
    setReimbursementSelectOpen(true);
  };
  const handleCloseReimbursementSelect = () => {
    setReimbursementMethodSearchKey('');
    setReimbursementSelectOpen(false);
  };
  const handleReimbursementChange = event => {
    var _store$homeDashboardS7, _store$homeDashboardS8;
    event.preventDefault();
    event.stopPropagation();
    if (event.target.value === 'no_results') return;
    store.payment.assignCompanyPayoutMethodToPropertyAsync.run({
      payoutMethodId: event.target.value,
      propertyId: (_store$homeDashboardS7 = store.homeDashboardStore.getCurrentProperty) === null || _store$homeDashboardS7 === void 0 ? void 0 : _store$homeDashboardS7.id
    }, [(_store$homeDashboardS8 = store.homeDashboardStore.getCurrentProperty) === null || _store$homeDashboardS8 === void 0 ? void 0 : _store$homeDashboardS8.id]).then(resp => {
      if (resp.isSuccessful) {
        var _store$homeDashboardS9;
        toast('success', {
          body: ['Successfully updated reimbursement method!']
        });
        store.homeDashboardStore.getCurrentCompany.fetchCompanyPayoutMethods({
          customInProgressFetchId: (_store$homeDashboardS9 = store.homeDashboardStore.getCurrentProperty) === null || _store$homeDashboardS9 === void 0 ? void 0 : _store$homeDashboardS9.id
        });
      }
    });
  };
  const getReimbursementMethodsList = () => {
    var _store$homeDashboardS0, _store$homeDashboardS1;
    const resultList = ((_store$homeDashboardS0 = store.homeDashboardStore.getCurrentCompany) === null || _store$homeDashboardS0 === void 0 ? void 0 : _store$homeDashboardS0.companyReimbursementMethods) !== null && ((_store$homeDashboardS1 = store.homeDashboardStore.getCurrentCompany) === null || _store$homeDashboardS1 === void 0 || (_store$homeDashboardS1 = _store$homeDashboardS1.companyReimbursementMethods) === null || _store$homeDashboardS1 === void 0 || (_store$homeDashboardS1 = _store$homeDashboardS1.filter(i => {
      var _store$homeDashboardS10;
      return !i.propertyIds.includes((_store$homeDashboardS10 = store.homeDashboardStore.getCurrentProperty) === null || _store$homeDashboardS10 === void 0 ? void 0 : _store$homeDashboardS10.id);
    })) === null || _store$homeDashboardS1 === void 0 ? void 0 : _store$homeDashboardS1.filter(i => {
      const searchPhrase = new RegExp(reimbursementMethodSearchKey, 'gi');
      return reimbursementMethodSearchKey.length > 0 ? " ".concat(i.nameOnAccount).search(searchPhrase) > 0 || " ".concat(i.depositoryName).search(searchPhrase) > 0 || " ".concat(i.routingNumber).search(searchPhrase) > 0 || " ".concat(i.accountNumber).search(searchPhrase) > 0 : true;
    }));
    if ((resultList === null || resultList === void 0 ? void 0 : resultList.length) > 0) {
      return resultList === null || resultList === void 0 ? void 0 : resultList.map(method => {
        if ((method === null || method === void 0 ? void 0 : method.methodType) === PAYMENT_METHODS.ACH) {
          return /*#__PURE__*/React.createElement(MenuItem, {
            value: method.id,
            className: classes.selectPayoutMethodItem
          }, /*#__PURE__*/React.createElement("span", null, "".concat(method.nameOnAccount, " ").concat(method !== null && method !== void 0 && method.depositoryName ? "(".concat(method.depositoryName, ")") : '')), /*#__PURE__*/React.createElement("i", null, "Routing: ".concat(method === null || method === void 0 ? void 0 : method.routingNumber, " ; Account: ").concat(method.accountNumber, ";")));
        }
      });
    } else {
      return /*#__PURE__*/React.createElement(MenuItem, {
        value: 'no_results',
        className: "".concat(classes.selectPayoutMethodItem, " disabled"),
        onClick: event => {
          event.preventDefault();
          event.stopPropagation();
        }
      }, /*#__PURE__*/React.createElement("span", null, t('general.no_matches_found')));
    }
  };
  // NOTE: END: Reimbursement methods section (aka payouts)

  const _useState11 = useState(false),
    _useState12 = _slicedToArray(_useState11, 2),
    isIncompletedProperty = _useState12[0],
    setIsIncompletedProperty = _useState12[1];
  const isCurrentPropertyIncompleted = ((_store$homeDashboardS11 = store.homeDashboardStore) === null || _store$homeDashboardS11 === void 0 || (_store$homeDashboardS11 = _store$homeDashboardS11.getCurrentProperty) === null || _store$homeDashboardS11 === void 0 ? void 0 : _store$homeDashboardS11.propertyStatus) === PROPERTY_STATUS_ENUM.Inactive || store.homeDashboardStore.selectedPropertyId === null && store.homeDashboardStore.selectedPropertyId !== 'all';
  const _useState13 = useState('all'),
    _useState14 = _slicedToArray(_useState13, 2),
    status = _useState14[0],
    setStatus = _useState14[1];
  const handleStatusChange = event => {
    if (event.target.value) setStatus(event.target.value);
  };
  const _useState15 = useState(''),
    _useState16 = _slicedToArray(_useState15, 2),
    residentTabSearchKey = _useState16[0],
    setResidentTabSearchKey = _useState16[1];
  const handleResidentSearchKeyChange = e => {
    setResidentTabSearchKey(e.target.value);
  };
  const RESIDENT_TAB_STATUSES_ENUM = {
    'general.all_types': [RESIDENCY_STATUS_KEY_VALUES.Current, RESIDENCY_STATUS_KEY_VALUES.Future, RESIDENCY_STATUS_KEY_VALUES.FormerActive, RESIDENCY_STATUS_KEY_VALUES.FormerClosed],
    'residencies_page.active_residents': [RESIDENCY_STATUS_KEY_VALUES.Current],
    'residencies_page.active_and_future_residents': [RESIDENCY_STATUS_KEY_VALUES.Current, RESIDENCY_STATUS_KEY_VALUES.Future],
    'residencies_page.future_residents': [RESIDENCY_STATUS_KEY_VALUES.Future],
    'residencies_page.former_residents': [RESIDENCY_STATUS_KEY_VALUES.FormerActive, RESIDENCY_STATUS_KEY_VALUES.FormerClosed]
  };
  const _useState17 = useState(Object.keys(RESIDENT_TAB_STATUSES_ENUM)[1]),
    _useState18 = _slicedToArray(_useState17, 2),
    residentTabStatus = _useState18[0],
    setResidentTabStatus = _useState18[1];
  const handleResidentsStatusChange = event => {
    if (event.target.value) {
      if (event.target.value === Object.keys(RESIDENT_TAB_STATUSES_ENUM)[Object.keys(RESIDENT_TAB_STATUSES_ENUM).length - 1]) {
        var _store$homeDashboardS12;
        (_store$homeDashboardS12 = store.homeDashboardStore.getCurrentCompany) === null || _store$homeDashboardS12 === void 0 || (_store$homeDashboardS12 = _store$homeDashboardS12.companyResidentsTabOptions) === null || _store$homeDashboardS12 === void 0 || _store$homeDashboardS12.updateModel({
          includeEmptyUnitsFlag: false
        });
      }
      setResidentTabStatus(event.target.value);
    }
  };
  const _useState19 = useState(null),
    _useState20 = _slicedToArray(_useState19, 2),
    companyData = _useState20[0],
    setCompanyData = _useState20[1];
  const _useState21 = useState(false),
    _useState22 = _slicedToArray(_useState21, 2),
    showCompanyAddressForm = _useState22[0],
    setShowCompanyAddressForm = _useState22[1];
  const _useState23 = useState(false),
    _useState24 = _slicedToArray(_useState23, 2),
    handleStartValidate = _useState24[0],
    setHandleStartValidate = _useState24[1];
  const _useState25 = useState(null),
    _useState26 = _slicedToArray(_useState25, 2),
    paperStatementGl = _useState26[0],
    setPaperStatementGl = _useState26[1];
  const handleTabChange = async (e, value) => {
    navigate(value);
    if (value === "".concat(basePath, "/details")) {
      const companyResp = await store.company.getCurrentUserCompanyFromTokenAsync.run();
      if (companyResp && companyResp.isSuccessful) {
        setCompanyData(companyResp.response);
      }
      if (store.company.companyFeatureStore.isAppfolio) {
        var _store$homeDashboardS13;
        // TODO: fix it to fetch GL accounts for Appfolio same as GLCodes
        await store.credentials.getGLAccountsAsync.run({
          applyToHomeDashboard: true
        });
        if ((_store$homeDashboardS13 = store.homeDashboardStore.getCurrentCompany.selectedPropertyDetails()) !== null && _store$homeDashboardS13 !== void 0 && (_store$homeDashboardS13 = _store$homeDashboardS13.details) !== null && _store$homeDashboardS13 !== void 0 && (_store$homeDashboardS13 = _store$homeDashboardS13.glCodeSetup) !== null && _store$homeDashboardS13 !== void 0 && _store$homeDashboardS13.rentGlAccountExternalId) {
          setShowRentGl(true);
        }
      }
    }
  };
  const handleGlCodeChange = async (type, value) => {
    var _toJS2;
    const data = (() => {
      switch (type) {
        case 'adminFeeGlAccountExternalId':
          return {
            adminFeeGlAccountExternalId: {
              value
            }
          };
        case 'glAccountExternalId':
          return {
            glAccountExternalId: {
              value
            }
          };
        case 'rentGlAccountExternalId':
          return {
            rentGlAccountExternalId: {
              value
            }
          };
        case 'paperStatementFeeGlAccountExternalId':
          return {
            paperStatementFeeGlAccountExternalId: {
              value
            }
          };
        case 'chargeOnDayOfMonth':
          return {
            chargeOnDayOfMonth: {
              value
            }
          };
        default:
          return null;
      }
    })();
    const resp = await store.credentials.patchAppfolioPropertiesAsync.run({
      properties: [_objectSpread({
        propertyLivableId: (_toJS2 = toJS(store.homeDashboardStore.getCurrentProperty)) === null || _toJS2 === void 0 ? void 0 : _toJS2.id
      }, data)]
    }, [type]);
    if (resp && resp.isSuccessful) {
      store.homeDashboardStore.getCurrentCompany.selectedPropertyDetails().details.glCodeSetup.updateGlCode(type, value);
      toast('success', {
        body: ['Successfully saved']
      });
    }
  };
  const handleRentGlSwitch = async () => {
    if (showRentGl) {
      setShowRentGl(false);
      await handleGlCodeChange('rentGlAccountExternalId', null);
    } else {
      setShowRentGl(true);
    }
  };
  const fetchPropertyUtilitiesData = async () => {
    var _store$homeDashboardS14;
    if ((_store$homeDashboardS14 = store.homeDashboardStore.getCurrentProperty) !== null && _store$homeDashboardS14 !== void 0 && _store$homeDashboardS14.id) {
      if (store.account.featureFlagsStore.getIsBillingTemplatesEnabled) {
        store.homeDashboardStore.getCurrentCompany.selectedPropertyDetails().details.fetchBillingTemplates();
        store.homeDashboardStore.getCurrentCompany.selectedPropertyDetails().details.fetchPropertyUtilityProviders();
      } else {
        store.homeDashboardStore.getCurrentCompany.selectedPropertyDetails().details.fetchUtilityTemplates();
      }
    }
  };
  const submitForm = useCallback(async () => {
    if (!(companyData !== null && companyData !== void 0 && companyData.addressId)) {
      setShowCompanyAddressForm(true);
      setHandleStartValidate(true);
      return;
    }
    await handleGlCodeChange(paperStatementGl.type, paperStatementGl.value);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [companyData === null || companyData === void 0 ? void 0 : companyData.addressId, handleGlCodeChange]);
  const handleStartSubmitting = async newAddressId => {
    let data = {
      companyType: companyData.companyType,
      name: companyData.name,
      propertyManagementSoftware: companyData.propertyManagementSoftware || '',
      addressId: newAddressId
    };
    if (newAddressId) {
      const addressResp = await store.address.batchGetAddressesAsync.run({
        addressIds: [newAddressId]
      });
      if (addressResp && addressResp.isSuccessful) {
        var _addressResp$response;
        data.postalAddress = "".concat(addressResp.response[0].street, " ").concat(addressResp.response[0].city, ", ").concat(addressResp.response[0].state, " ").concat(addressResp.response[0].zip).concat((_addressResp$response = addressResp.response[0]) !== null && _addressResp$response !== void 0 && _addressResp$response.secondary ? ', ' + addressResp.response[0].secondary : '');
      }
    }
    const resp = await store.company.updateCompanyAsync.run(data);
    if (resp && resp.isSuccessful) {
      setCompanyData(_objectSpread(_objectSpread({}, companyData), {}, {
        addressId: newAddressId
      }));
      setShowCompanyAddressForm(false);
      toast('success', {
        body: ['Company address saved']
      });
    }
    await handleGlCodeChange(paperStatementGl.type, paperStatementGl.value);
  };
  const handleEndSubmitting = () => {
    setHandleStartValidate(false);
  };
  const _useState27 = useState('create'),
    _useState28 = _slicedToArray(_useState27, 2),
    billingAutomationSetupModalStatesDemo = _useState28[0],
    setBillingAutomationSetupModalStatesDemo = _useState28[1]; // NOTE: for demo purposes statuses - create | activate | activated
  // TODO: add this functionality
  // const handleBillingAutomationSetupModalStatesDemo = state => {
  //   switch (state) {
  //     case 'activate':
  //       setBillingAutomationSetupModalStatesDemo(state);
  //       break;
  //     case 'activated':
  //       setBillingAutomationSetupModalStatesDemo(state);
  //       break;
  //     case 'create':
  //     default:
  //       setBillingAutomationSetupModalStatesDemo(state);
  //       break;
  //   }
  // };

  const _useState29 = useState(false),
    _useState30 = _slicedToArray(_useState29, 2),
    removeTemplateModalState = _useState30[0],
    setRemoveTemplateModalState = _useState30[1];
  const _useState31 = useState(null),
    _useState32 = _slicedToArray(_useState31, 2),
    removeTemplateModalPassoverObject = _useState32[0],
    setRemoveTemplateModalPassoverObject = _useState32[1];
  const _useState33 = useState(null),
    _useState34 = _slicedToArray(_useState33, 2),
    removeTemplateModalBodyText = _useState34[0],
    setRemoveTemplateModalBodyText = _useState34[1];
  const deletePropertyUtility = _ref2 => {
    let propertyUtilityId = _ref2.propertyUtilityId,
      urjanetCredentialsForProvider = _ref2.urjanetCredentialsForProvider,
      utilityName = _ref2.utilityName,
      providerName = _ref2.providerName,
      utilityId = _ref2.utilityId;
    setRemoveTemplateModalBodyText(null);
    setRemoveTemplateModalPassoverObject({
      propertyUtilityId,
      urjanetCredentialsForProvider,
      utilityId
    });
    setRemoveTemplateModalBodyText(t('add_new_property_flow.delete_billing_template_confirmation_body', {
      utilityName,
      providerName
    }));
    setRemoveTemplateModalState(true);
  };
  const deletePropertyUtilitySubmitHandle = async _ref3 => {
    let propertyUtilityId = _ref3.propertyUtilityId,
      urjanetCredentialsForProvider = _ref3.urjanetCredentialsForProvider,
      utilityId = _ref3.utilityId;
    // setIsLoading(true);

    // if (urjanetCredentialsForProvider !== null && !!urjanetCredentialsForProvider?.id) {
    //   const deleteCredentialsResp = await store.urjanet.deleteCredentialsAsync.run({
    //     id: urjanetCredentialsForProvider?.id,
    //   });
    //   if (!deleteCredentialsResp.isSuccessful) {
    //     toast('error', { body: ['Credentials not deleted'] });
    //     // setIsLoading(false);
    //     // setFetchTrigger(!fetchTrigger);
    //     setRemoveTemplateModalPassoverObject(null);
    //     return;
    //   }
    // }

    if (store.account.featureFlagsStore.getIsBillingTemplatesEnabled) {
      store.propertyUtility.deletePropertyUtilityAsync.run({
        propertyUtilityId
      }, [propertyUtilityId]).then(resp => {
        if (resp.isSuccessful) {
          toast('success', {
            body: ['Successfully deleted']
          });
        }
        store.homeDashboardStore.getCurrentCompany.selectedPropertyDetails().details.fetchBillingTemplates({
          forceUpdate: true,
          useUnicInProgress: false,
          customUnicInProgress: [propertyUtilityId]
        });
        store.homeDashboardStore.getCurrentCompany.selectedPropertyDetails().details.fetchPropertyUtilityProviders({
          useUnicInProgress: false,
          customUnicInProgress: [propertyUtilityId]
        });
      });
    } else {
      var _store$homeDashboardS15;
      store.propertyUtility.deleteNewPropertyUtilityConfigAsync.run({
        propertyId: (_store$homeDashboardS15 = store.homeDashboardStore.getCurrentProperty) === null || _store$homeDashboardS15 === void 0 ? void 0 : _store$homeDashboardS15.id,
        utilityId: utilityId,
        propertyUtilityId: utilityId
      }, [utilityId]).then(resp => {
        if (resp.isSuccessful) {
          toast('success', {
            body: ['Successfully deleted']
          });
        }
        store.homeDashboardStore.getCurrentCompany.selectedPropertyDetails().details.fetchUtilityTemplates({
          forceUpdate: true,
          useUnicInProgress: false,
          customUnicInProgress: [utilityId]
        });
      });
    }
    setRemoveTemplateModalPassoverObject(null);
  };
  const deletePropertyUtilityConfirmationActionHandler = _ref4 => {
    let action = _ref4.action,
      objectToPassOver = _ref4.objectToPassOver;
    if (action === 'submit') {
      deletePropertyUtilitySubmitHandle(objectToPassOver);
    }
    setRemoveTemplateModalState(false);
  };
  const _useState35 = useState(false),
    _useState36 = _slicedToArray(_useState35, 2),
    removeAmenityModalState = _useState36[0],
    setRemoveAmenityModalState = _useState36[1];
  const _useState37 = useState(null),
    _useState38 = _slicedToArray(_useState37, 2),
    removeAmenityModalPassoverObject = _useState38[0],
    setRemoveAmenityModalPassoverObject = _useState38[1];
  const _useState39 = useState(null),
    _useState40 = _slicedToArray(_useState39, 2),
    removeAmenityModalBodyText = _useState40[0],
    setRemoveAmenityModalBodyText = _useState40[1];
  const deletePropertyAmenity = _ref5 => {
    var _store$homeDashboardS16;
    let amenityObj = _ref5.amenityObj;
    setRemoveAmenityModalBodyText(null);
    setRemoveAmenityModalPassoverObject(amenityObj);
    setRemoveAmenityModalBodyText(t('add_new_property_flow.delete_amenity_confirmation_body', {
      amenityName: amenityObj.amenityDetails.name,
      propertyAddressName: (_store$homeDashboardS16 = store.homeDashboardStore.getCurrentProperty) === null || _store$homeDashboardS16 === void 0 || (_store$homeDashboardS16 = _store$homeDashboardS16.propertyInformation) === null || _store$homeDashboardS16 === void 0 ? void 0 : _store$homeDashboardS16.propertyAddress
    }));
    setRemoveAmenityModalState(true);
  };
  const deleteAmenitySubmitHandle = async objectToPassOver => {
    var _store$homeDashboardS17;
    await store.utilityProviders.patchPropertyCommonAreaAmenitiesAsync.run({
      propertyId: (_store$homeDashboardS17 = store.homeDashboardStore.getCurrentProperty) === null || _store$homeDashboardS17 === void 0 ? void 0 : _store$homeDashboardS17.id,
      toCreate: [],
      toUpdate: [],
      toDelete: [objectToPassOver.commonAreaAmenityId]
    }, [objectToPassOver.commonAreaAmenityId, objectToPassOver.id]).then(resp => {
      if (resp !== null && resp !== void 0 && resp.isSuccessful) {
        toast('success', {
          body: ['Successfully deleted amenity']
        });
      }
      store.homeDashboardStore.getCurrentProperty.details.fetchAmenities({
        forceUpdate: true,
        useUnicInProgress: true,
        customUnicInProgress: [objectToPassOver.id]
      });
    });
  };
  const deleteAmenityConfirmationActionHandler = _ref6 => {
    let action = _ref6.action,
      objectToPassOver = _ref6.objectToPassOver;
    if (action === 'submit') {
      deleteAmenitySubmitHandle(objectToPassOver);
    }
    setRemoveAmenityModalState(false);
  };
  const getCompanySwitchInProgress = () => {
    var _store$portfolios$get, _store$company$getCur;
    return store.admin.getAdminAccountLoginImpersonateAsync.inProgress || store.account.refreshAccessTokenAsync.inProgress || ((_store$portfolios$get = store.portfolios.getPortfoliosDashboardAsync.inProgressUnicIds) === null || _store$portfolios$get === void 0 ? void 0 : _store$portfolios$get.includes(store.homeDashboardStore.companyAccessId + 'setCompanyAccessId')) || ((_store$company$getCur = store.company.getCurrentUserCompanyFromTokenAsync.inProgressUnicIds) === null || _store$company$getCur === void 0 ? void 0 : _store$company$getCur.includes(store.homeDashboardStore.companyAccessId + 'setCompanyAccessId'));
  };
  const getPropertyDashboardLoadingStatus = unicTag => {
    var _store$portfolios$get2;
    return (_store$portfolios$get2 = store.portfolios.getPortfoliosDashboardAsync.inProgressUnicIds) === null || _store$portfolios$get2 === void 0 ? void 0 : _store$portfolios$get2.includes(store.homeDashboardStore.companyAccessId, unicTag);
  };
  const getBillingItemLoadingStatus = unicTag => {
    var _store$utilityProvide, _store$utilityProvide2, _store$utilityProvide3, _store$utilityProvide4, _store$utilityProvide5, _store$propertyUtilit, _store$propertyUtilit2, _store$propertyUtilit3, _store$properties$get;
    return ((_store$utilityProvide = store.utilityProviders.addPropertyUtilityProviderAsync) === null || _store$utilityProvide === void 0 || (_store$utilityProvide = _store$utilityProvide.inProgressUnicIds) === null || _store$utilityProvide === void 0 ? void 0 : _store$utilityProvide.includes(unicTag)) || ((_store$utilityProvide2 = store.utilityProviders.addCustomUtilityProvidersV2Async) === null || _store$utilityProvide2 === void 0 || (_store$utilityProvide2 = _store$utilityProvide2.inProgressUnicIds) === null || _store$utilityProvide2 === void 0 ? void 0 : _store$utilityProvide2.includes(unicTag)) || ((_store$utilityProvide3 = store.utilityProviders.editCustomUtilityProvidersAsync) === null || _store$utilityProvide3 === void 0 || (_store$utilityProvide3 = _store$utilityProvide3.inProgressUnicIds) === null || _store$utilityProvide3 === void 0 ? void 0 : _store$utilityProvide3.includes(unicTag)) || ((_store$utilityProvide4 = store.utilityProviders.createPropertyUtilitiesAsync) === null || _store$utilityProvide4 === void 0 || (_store$utilityProvide4 = _store$utilityProvide4.inProgressUnicIds) === null || _store$utilityProvide4 === void 0 ? void 0 : _store$utilityProvide4.includes(unicTag)) || ((_store$utilityProvide5 = store.utilityProviders.createCustomUtilityTypeAndAttachToProviderAsync) === null || _store$utilityProvide5 === void 0 || (_store$utilityProvide5 = _store$utilityProvide5.inProgressUnicIds) === null || _store$utilityProvide5 === void 0 ? void 0 : _store$utilityProvide5.includes(unicTag)) || ((_store$propertyUtilit = store.propertyUtility.updatePropertyUtilitiesAsync) === null || _store$propertyUtilit === void 0 || (_store$propertyUtilit = _store$propertyUtilit.inProgressUnicIds) === null || _store$propertyUtilit === void 0 ? void 0 : _store$propertyUtilit.includes(unicTag)) || ((_store$propertyUtilit2 = store.propertyUtility.deletePropertyUtilityAsync) === null || _store$propertyUtilit2 === void 0 || (_store$propertyUtilit2 = _store$propertyUtilit2.inProgressUnicIds) === null || _store$propertyUtilit2 === void 0 ? void 0 : _store$propertyUtilit2.includes(unicTag)) || ((_store$propertyUtilit3 = store.propertyUtility.getPropertyUtilitiesByPropertyAsync) === null || _store$propertyUtilit3 === void 0 || (_store$propertyUtilit3 = _store$propertyUtilit3.inProgressUnicIds) === null || _store$propertyUtilit3 === void 0 ? void 0 : _store$propertyUtilit3.includes(unicTag)) || ((_store$properties$get = store.properties.getPropertyUtilityProvidersV3Async) === null || _store$properties$get === void 0 || (_store$properties$get = _store$properties$get.inProgressUnicIds) === null || _store$properties$get === void 0 ? void 0 : _store$properties$get.includes(unicTag));
  };
  const getUtilityItemLoadingStatus = unicTag => {
    var _store$propertyUtilit4, _store$propertyUtilit5, _store$propertyUtilit6, _store$utilityProvide6, _store$utilityProvide7, _store$properties$get2, _store$utilityProvide8;
    return ((_store$propertyUtilit4 = store.propertyUtility.addNewPropertyUtilityConfigBatchAsync.inProgressUnicIds) === null || _store$propertyUtilit4 === void 0 ? void 0 : _store$propertyUtilit4.includes(unicTag)) || ((_store$propertyUtilit5 = store.propertyUtility.updateNewPropertyUtilityConfigAsync.inProgressUnicIds) === null || _store$propertyUtilit5 === void 0 ? void 0 : _store$propertyUtilit5.includes(unicTag)) || ((_store$propertyUtilit6 = store.propertyUtility.deleteNewPropertyUtilityConfigAsync.inProgressUnicIds) === null || _store$propertyUtilit6 === void 0 ? void 0 : _store$propertyUtilit6.includes(unicTag)) || ((_store$utilityProvide6 = store.utilityProviders.editCustomUtilityProvidersAsync.inProgressUnicIds) === null || _store$utilityProvide6 === void 0 ? void 0 : _store$utilityProvide6.includes(unicTag)) || ((_store$utilityProvide7 = store.utilityProviders.addCustomUtilityProvidersV2Async.inProgressUnicIds) === null || _store$utilityProvide7 === void 0 ? void 0 : _store$utilityProvide7.includes(unicTag)) || ((_store$properties$get2 = store.properties.getPropertyUtilityProvidersV3Async.inProgressUnicIds) === null || _store$properties$get2 === void 0 ? void 0 : _store$properties$get2.includes(unicTag)) || ((_store$utilityProvide8 = store.utilityProviders.createCustomUtilityTypeAndAttachToProviderAsync.inProgressUnicIds) === null || _store$utilityProvide8 === void 0 ? void 0 : _store$utilityProvide8.includes(unicTag));
  };
  const getAmenityItemLoadingStatus = unicTag => {
    var _store$properties$add, _store$utilityProvide9, _store$utilityProvide0, _store$utilityProvide1;
    return ((_store$properties$add = store.properties.addPropertyCommonAreaAmenityAsync.inProgressUnicIds) === null || _store$properties$add === void 0 ? void 0 : _store$properties$add.includes(unicTag)) || ((_store$utilityProvide9 = store.utilityProviders.getPropertyCommonAreaAmenitiesAsync.inProgressUnicIds) === null || _store$utilityProvide9 === void 0 ? void 0 : _store$utilityProvide9.includes(unicTag)) || ((_store$utilityProvide0 = store.utilityProviders.getPropertyCommonAreaAmenitiesAsync.inProgressUnicIds) === null || _store$utilityProvide0 === void 0 ? void 0 : _store$utilityProvide0.includes(store.homeDashboardStore.getCurrentProperty.id)) || ((_store$utilityProvide1 = store.utilityProviders.patchPropertyCommonAreaAmenitiesAsync) === null || _store$utilityProvide1 === void 0 || (_store$utilityProvide1 = _store$utilityProvide1.inProgressUnicIds) === null || _store$utilityProvide1 === void 0 ? void 0 : _store$utilityProvide1.includes(unicTag));
  };
  const getPropertyInformationLoadingStatus = unicTag => {
    var _store$properties$get3, _store$buildings$getB, _store$properties$upd, _store$portfolios$get3;
    return ((_store$properties$get3 = store.properties.getPropertyAsync) === null || _store$properties$get3 === void 0 || (_store$properties$get3 = _store$properties$get3.inProgressUnicIds) === null || _store$properties$get3 === void 0 ? void 0 : _store$properties$get3.includes(unicTag)) || ((_store$buildings$getB = store.buildings.getBuildingAsync) === null || _store$buildings$getB === void 0 || (_store$buildings$getB = _store$buildings$getB.inProgressUnicIds) === null || _store$buildings$getB === void 0 ? void 0 : _store$buildings$getB.includes(unicTag)) || ((_store$properties$upd = store.properties.updatePropertyAsync) === null || _store$properties$upd === void 0 || (_store$properties$upd = _store$properties$upd.inProgressUnicIds) === null || _store$properties$upd === void 0 ? void 0 : _store$properties$upd.includes(unicTag)) || ((_store$portfolios$get3 = store.portfolios.getPortfoliosDashboardAsync) === null || _store$portfolios$get3 === void 0 || (_store$portfolios$get3 = _store$portfolios$get3.inProgressUnicIds) === null || _store$portfolios$get3 === void 0 ? void 0 : _store$portfolios$get3.includes(unicTag));
  };
  const getContactInformationLoadingStatus = unicTag => {
    var _store$properties$get4, _store$properties$upd2, _store$properties$upd3, _store$teamMembers$ge, _store$portfolios$get4;
    return ((_store$properties$get4 = store.properties.getPropertysContactsAsync) === null || _store$properties$get4 === void 0 || (_store$properties$get4 = _store$properties$get4.inProgressUnicIds) === null || _store$properties$get4 === void 0 ? void 0 : _store$properties$get4.includes(unicTag)) || ((_store$properties$upd2 = store.properties.updatePropertyAsync) === null || _store$properties$upd2 === void 0 || (_store$properties$upd2 = _store$properties$upd2.inProgressUnicIds) === null || _store$properties$upd2 === void 0 ? void 0 : _store$properties$upd2.includes(unicTag)) || ((_store$properties$upd3 = store.properties.updatePropertysContactsAsync) === null || _store$properties$upd3 === void 0 || (_store$properties$upd3 = _store$properties$upd3.inProgressUnicIds) === null || _store$properties$upd3 === void 0 ? void 0 : _store$properties$upd3.includes(unicTag)) || ((_store$teamMembers$ge = store.teamMembers.getCompanyTeamMembersAsync) === null || _store$teamMembers$ge === void 0 || (_store$teamMembers$ge = _store$teamMembers$ge.inProgressUnicIds) === null || _store$teamMembers$ge === void 0 ? void 0 : _store$teamMembers$ge.includes(unicTag)) || ((_store$portfolios$get4 = store.portfolios.getPortfoliosDashboardAsync) === null || _store$portfolios$get4 === void 0 || (_store$portfolios$get4 = _store$portfolios$get4.inProgressUnicIds) === null || _store$portfolios$get4 === void 0 ? void 0 : _store$portfolios$get4.includes(unicTag));
  };
  const getPropertyReimbursementLoadingStatus = unicTag => {
    var _store$payment$getCom, _store$payment$getCom2, _store$payment$putPay, _store$payment$postPa, _store$payment$putPay2, _store$payment$postPa2, _store$payment$getCom3, _store$payment$postCo, _store$payment$assign;
    return ((_store$payment$getCom = store.payment.getCompanyAchDirectDepositsListAsync) === null || _store$payment$getCom === void 0 || (_store$payment$getCom = _store$payment$getCom.inProgressUnicIds) === null || _store$payment$getCom === void 0 ? void 0 : _store$payment$getCom.includes(unicTag)) || ((_store$payment$getCom2 = store.payment.getCompanyPayoutRegularChecksListAsync) === null || _store$payment$getCom2 === void 0 || (_store$payment$getCom2 = _store$payment$getCom2.inProgressUnicIds) === null || _store$payment$getCom2 === void 0 ? void 0 : _store$payment$getCom2.includes(unicTag)) || ((_store$payment$putPay = store.payment.putPayoutAchDirectDepositAsync) === null || _store$payment$putPay === void 0 || (_store$payment$putPay = _store$payment$putPay.inProgressUnicIds) === null || _store$payment$putPay === void 0 ? void 0 : _store$payment$putPay.includes(unicTag)) || ((_store$payment$postPa = store.payment.postPayoutAchDirectDepositAsync) === null || _store$payment$postPa === void 0 || (_store$payment$postPa = _store$payment$postPa.inProgressUnicIds) === null || _store$payment$postPa === void 0 ? void 0 : _store$payment$postPa.includes(unicTag)) || ((_store$payment$putPay2 = store.payment.putPayoutRegularCheckAsync) === null || _store$payment$putPay2 === void 0 || (_store$payment$putPay2 = _store$payment$putPay2.inProgressUnicIds) === null || _store$payment$putPay2 === void 0 ? void 0 : _store$payment$putPay2.includes(unicTag)) || ((_store$payment$postPa2 = store.payment.postPayoutRegularCheckAsync) === null || _store$payment$postPa2 === void 0 || (_store$payment$postPa2 = _store$payment$postPa2.inProgressUnicIds) === null || _store$payment$postPa2 === void 0 ? void 0 : _store$payment$postPa2.includes(unicTag)) || ((_store$payment$getCom3 = store.payment.getCompanyPayoutMethodsAsync) === null || _store$payment$getCom3 === void 0 || (_store$payment$getCom3 = _store$payment$getCom3.inProgressUnicIds) === null || _store$payment$getCom3 === void 0 ? void 0 : _store$payment$getCom3.includes(unicTag)) || ((_store$payment$postCo = store.payment.postCompanyPayoutMethodAsync) === null || _store$payment$postCo === void 0 || (_store$payment$postCo = _store$payment$postCo.inProgressUnicIds) === null || _store$payment$postCo === void 0 ? void 0 : _store$payment$postCo.includes(unicTag)) || ((_store$payment$assign = store.payment.assignCompanyPayoutMethodToPropertyAsync) === null || _store$payment$assign === void 0 || (_store$payment$assign = _store$payment$assign.inProgressUnicIds) === null || _store$payment$assign === void 0 ? void 0 : _store$payment$assign.includes(unicTag));
  };
  const _useState41 = useState(false),
    _useState42 = _slicedToArray(_useState41, 2),
    isAssignPropertiesToPortfolioModalOpen = _useState42[0],
    setIsAssignPropertiesToPortfolioModalOpen = _useState42[1];
  const openPropertyDetails = id => {
    store.homeDashboardStore.selectActivePropertyId(id);
    handleTabChange(undefined, "/active_dashboard/".concat(COMPANY_ID, "/all/").concat(id, "/details"));
  };
  const getPaymentInfo = async () => {
    var _toJS3;
    await store.payment.getPaymentMethodsV2Async.run({
      applyToHomeDashboard: true
    });
    await store.payment.getPropertyPaymentMethodAsync.run({
      applyToHomeDashboard: true,
      propertyId: (_toJS3 = toJS(store.homeDashboardStore.getCurrentProperty)) === null || _toJS3 === void 0 ? void 0 : _toJS3.id
    });
  };
  const getPropertyFees = async () => {
    var _toJS4;
    await store.payment.getStripeProductsAsync.run();
    await store.properties.getPropertyFeesV2Async.run({
      applyToStore: true,
      applyToHomeDashboard: true,
      propertyId: (_toJS4 = toJS(store.homeDashboardStore.getCurrentProperty)) === null || _toJS4 === void 0 ? void 0 : _toJS4.id
    });
  };
  useEffect(() => {
    var _store$homeDashboardS18;
    let isPropertyIdValid = true;
    switch ((_store$homeDashboardS18 = store.homeDashboardStore.getCurrentProperty) === null || _store$homeDashboardS18 === void 0 ? void 0 : _store$homeDashboardS18.id) {
      case 'portfolio_details':
      case 'all':
      case null:
      case undefined:
        {
          isPropertyIdValid = false;
          break;
        }
    }
    if (currentTab === "".concat(basePath, "/details") && isPropertyIdValid) {
      var _store$homeDashboardS19, _store$homeDashboardS20, _store$homeDashboardS21, _store$homeDashboardS22;
      getPaymentInfo();
      fetchPropertyUtilitiesData();
      getPropertyFees();
      if (!store.stripe.subscriptionCompanySubscriptions.length && !store.stripe.getSubscriptionCompanyAsync.inProgress) {
        store.stripe.getSubscriptionCompanyAsync.run();
      }
      if ((_store$homeDashboardS19 = store.homeDashboardStore.getCurrentProperty) !== null && _store$homeDashboardS19 !== void 0 && (_store$homeDashboardS19 = _store$homeDashboardS19.buildingInformation) !== null && _store$homeDashboardS19 !== void 0 && _store$homeDashboardS19.id) store.units.getUnitsAsync.run({
        buildingId: (_store$homeDashboardS20 = store.homeDashboardStore.getCurrentProperty) === null || _store$homeDashboardS20 === void 0 || (_store$homeDashboardS20 = _store$homeDashboardS20.buildingInformation) === null || _store$homeDashboardS20 === void 0 ? void 0 : _store$homeDashboardS20.id,
        applyToHomeDashboard: true
      }, [(_store$homeDashboardS21 = store.homeDashboardStore.getCurrentProperty) === null || _store$homeDashboardS21 === void 0 ? void 0 : _store$homeDashboardS21.id]);
      (_store$homeDashboardS22 = store.homeDashboardStore.getCurrentCompany) === null || _store$homeDashboardS22 === void 0 || _store$homeDashboardS22.fetchCompanyPortfoliosData({});
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentTab, (_store$homeDashboardS23 = store.homeDashboardStore.getCurrentProperty) === null || _store$homeDashboardS23 === void 0 ? void 0 : _store$homeDashboardS23.id, (_store$homeDashboardS24 = store.homeDashboardStore.getCurrentProperty) === null || _store$homeDashboardS24 === void 0 || (_store$homeDashboardS24 = _store$homeDashboardS24.buildingInformation) === null || _store$homeDashboardS24 === void 0 ? void 0 : _store$homeDashboardS24.id]);
  const PortfolioHeaderSettingsTeammembersBlock = _ref7 => {
    let items = _ref7.items;
    const maxVisibleItems = 3;
    if (!items || items.length === 0) {
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Button, {
        variant: "actionIcon",
        size: "small",
        className: classes.newPortfolioManage,
        onClick: event => {
          event.stopPropagation();
          event.preventDefault();
          handleShowManageAccessModal(true, null, store.homeDashboardStore.getCurrentPortfolio);
        }
      }, /*#__PURE__*/React.createElement(Icon, {
        type: "user-add"
      })));
    }
    const visibleItems = [...items].slice(0, maxVisibleItems);
    const remainingCount = items.length - maxVisibleItems;
    return /*#__PURE__*/React.createElement("div", {
      className: classes.portfolioDetailsHeaderUsersList,
      onClick: event => {
        event.stopPropagation();
        event.preventDefault();
        handleShowManageAccessModal(true, null, store.homeDashboardStore.getCurrentPortfolio);
      }
    }, /*#__PURE__*/React.createElement(React.Fragment, null, visibleItems.map((item, index) => /*#__PURE__*/React.createElement(BasicTooltip, {
      title: "".concat(item.firstName, " ").concat(item.lastName),
      key: "".concat(index),
      placement: "top"
    }, /*#__PURE__*/React.createElement("span", null, item.firstName.toUpperCase().charAt(0)))), (items === null || items === void 0 ? void 0 : items.length) > maxVisibleItems && /*#__PURE__*/React.createElement("span", {
      className: "total"
    }, "+", remainingCount)));
  };
  const _React$useState = React.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    isRemoveConfirmationModalOpen = _React$useState2[0],
    setIsRemoveConfirmationModalOpen = _React$useState2[1];
  const _useState43 = useState(null),
    _useState44 = _slicedToArray(_useState43, 2),
    removePortfolioFromPropertyModalPassoverObject = _useState44[0],
    setRemovePortfolioFromPropertyModalPassoverObject = _useState44[1];
  const removePortfolioActionHandler = (propertyItem, portfolioIdToExclude) => {
    var _propertyItem$propert;
    const portfolioIdsFiltered = Array.from(new Set((_propertyItem$propert = propertyItem.propertyInformation) === null || _propertyItem$propert === void 0 ? void 0 : _propertyItem$propert.portfolioIds)).filter(propertyPortfolioId => {
      var _store$homeDashboardS25;
      return propertyPortfolioId !== portfolioIdToExclude && ((_store$homeDashboardS25 = store.homeDashboardStore.getCurrentCompany) === null || _store$homeDashboardS25 === void 0 || (_store$homeDashboardS25 = _store$homeDashboardS25.companyPortfolioDataDetails(propertyPortfolioId)) === null || _store$homeDashboardS25 === void 0 ? void 0 : _store$homeDashboardS25.isDefault) !== true;
    });
    store.portfolios.editPropertyPortfoliosRelationshipAsync.run({
      propertyId: propertyItem === null || propertyItem === void 0 ? void 0 : propertyItem.id,
      portfolioIds: portfolioIdsFiltered
    }).then(resp => {
      if (resp !== null && resp !== void 0 && resp.isSuccessful) {
        var _store$homeDashboardS26, _store$homeDashboardS27;
        if (!((_store$homeDashboardS26 = store.homeDashboardStore.getCurrentProperty) !== null && _store$homeDashboardS26 !== void 0 && _store$homeDashboardS26.id) || propertyItem.id === ((_store$homeDashboardS27 = store.homeDashboardStore.getCurrentProperty) === null || _store$homeDashboardS27 === void 0 ? void 0 : _store$homeDashboardS27.id) && !portfolioIdsFiltered.includes(store.homeDashboardStore.getCurrentPortfolio.id)) {
          store.homeDashboardStore.selectActivePropertyId('portfolio_details');
        }
        toast('success', {
          body: ['Successfully Removed']
        });
      }
      triggerRefreshPortfolioData();
    }).finally(() => {
      setRemovePortfolioFromPropertyModalPassoverObject(null);
      setIsRemoveConfirmationModalOpen(false);
    });
  };
  const handleRemovePortfolioFromProperty = _ref8 => {
    let payload = _ref8.payload,
      portfolioId = _ref8.portfolioId;
    setRemovePortfolioFromPropertyModalPassoverObject({
      payload,
      portfolioId
    });
    setIsRemoveConfirmationModalOpen(true);
  };
  const _useState45 = useState(false),
    _useState46 = _slicedToArray(_useState45, 2),
    isAssignPortfoliosToPropertyModalOpen = _useState46[0],
    setIsAssignPortfoliosToPropertyModalOpen = _useState46[1];
  const _useState47 = useState(null),
    _useState48 = _slicedToArray(_useState47, 2),
    assignPortfoliosToPropertyModalPassoverObject = _useState48[0],
    setAssignPortfoliosToPropertyModalPassoverObject = _useState48[1];
  const handleOpenAssignPortfoliosToPropertyModal = data => {
    var _store$homeDashboardS28, _store$homeDashboardS29;
    (_store$homeDashboardS28 = store.homeDashboardStore.getCurrentCompany) === null || _store$homeDashboardS28 === void 0 || _store$homeDashboardS28.fetchPropertyInformationBatch([{
      propertyId: data.property.id,
      portfolioId: data.property.propertyPortfolioInfo.id
    }]);
    (_store$homeDashboardS29 = store.homeDashboardStore.getCurrentCompany) === null || _store$homeDashboardS29 === void 0 || _store$homeDashboardS29.fetchBuildingsInformationBatch([{
      propertyId: data.property.id,
      portfolioId: data.property.propertyPortfolioInfo.id
    }]);
    setAssignPortfoliosToPropertyModalPassoverObject(data.property);
    setIsAssignPortfoliosToPropertyModalOpen(true);
  };
  const smartNavSelectActionCallbackHandler = _ref9 => {
    var _store$homeDashboardS30;
    let entityType = _ref9.entityType,
      _id = _ref9._id,
      prefetchDataOnly = _ref9.prefetchDataOnly;
    (_store$homeDashboardS30 = store.homeDashboardStore.currentAbortController) === null || _store$homeDashboardS30 === void 0 || _store$homeDashboardS30.abort();
    const controller = new AbortController();
    store.homeDashboardStore.setAbortController(controller);
    if (_id === 'all') {
      var _store$homeDashboardS31;
      navigate("/active_dashboard/".concat(COMPANY_ID, "/all/all"), {
        replace: true
      });
      if (currentTab === "".concat(basePath, "/details") || isIncompletedProperty) {
        setIsIncompletedProperty(false);
      }
      (_store$homeDashboardS31 = store.homeDashboardStore.getCurrentCompany) === null || _store$homeDashboardS31 === void 0 || (_store$homeDashboardS31 = _store$homeDashboardS31.companyResidentsTabOptions) === null || _store$homeDashboardS31 === void 0 || _store$homeDashboardS31.updateModel({
        includeEmptyUnitsFlag: false
      });
      store.homeDashboardStore.selectActivePortfolioId(_id);
      store.homeDashboardStore.selectActivePropertyId(_id);
      return;
    }
    if (entityType === 'portfolio') {
      store.homeDashboardStore.selectActivePortfolioId(_id);
      navigate("/active_dashboard/".concat(COMPANY_ID, "/").concat(_id, "/all"), {
        replace: true
      });
    }
    if (entityType === 'property') {
      store.homeDashboardStore.selectActivePropertyId(_id, prefetchDataOnly);
      if (!prefetchDataOnly) {
        var _store$homeDashboardS32;
        (_store$homeDashboardS32 = store.homeDashboardStore.getCurrentCompany) === null || _store$homeDashboardS32 === void 0 || (_store$homeDashboardS32 = _store$homeDashboardS32.companyResidentsTabOptions) === null || _store$homeDashboardS32 === void 0 || _store$homeDashboardS32.updateModel({
          includeEmptyUnitsFlag: true
        });
        navigate("/active_dashboard/".concat(COMPANY_ID, "/all/").concat(_id), {
          replace: true
        });
      }
    }
    if (entityType === 'new_property') {
      if (_id === null) {
        setIsIncompletedProperty(true);
        store.homeDashboardStore.selectActivePropertyId(_id, prefetchDataOnly);
        return;
      }
    }
    if (entityType === 'portfolio_details') {
      if (_id === null) {
        // setIsIncompletedProperty(true);
        store.homeDashboardStore.selectActivePropertyId('portfolio_details', prefetchDataOnly);
        // navigate(`/active_dashboard/${COMPANY_ID}/all/all`, { replace: true });
        return;
      }
    }
    if (entityType === 'add_properties_to_portfolio') {
      var _store$homeDashboardS33, _store$homeDashboardS34, _store$homeDashboardS35;
      store.homeDashboardStore.selectActivePortfolioId(_id);
      const propertyPortfolioSet = (_store$homeDashboardS33 = store.homeDashboardStore.getCurrentCompany) === null || _store$homeDashboardS33 === void 0 ? void 0 : _store$homeDashboardS33.getAllUnicCompanyProperties.map(i => {
        return {
          propertyId: i.id,
          portfolioId: i.propertyPortfolioInfo.id
        };
      }).flat();
      (_store$homeDashboardS34 = store.homeDashboardStore.getCurrentCompany) === null || _store$homeDashboardS34 === void 0 || _store$homeDashboardS34.fetchPropertyInformationBatch(propertyPortfolioSet);
      (_store$homeDashboardS35 = store.homeDashboardStore.getCurrentCompany) === null || _store$homeDashboardS35 === void 0 || _store$homeDashboardS35.fetchBuildingsInformationBatch(propertyPortfolioSet);
      setIsAssignPropertiesToPortfolioModalOpen(true);
      // store.homeDashboardStore.selectActivePropertyId('all');
    }
  };
  return /*#__PURE__*/React.createElement("div", {
    className: classes.allocationPage
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.allocationPageContent
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.allocation
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.allocationContent
  }, (store.account.userProfile.isUserAdmin || store.account.userProfile.isUserSuperAdmin) && /*#__PURE__*/React.createElement("div", {
    className: classes.allocationNav
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.allocationNavPortfolios
  }, /*#__PURE__*/React.createElement(CompaniesSelector, {
    handleOpenCreateAccountModal: handleOpenCreateAccountModal
  }))), /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes.allocationBody, " ").concat(store.payment.failedPaymentMethods && store.payment.warningPaymentMethods && history.pathname !== '/admin' && history.pathname !== '/appfolio' && history.pathname !== '/information_banners' ? 'paymentMarginWarningBoth' : (store.payment.failedPaymentMethods || store.payment.warningPaymentMethods) && history.pathname !== '/admin' && history.pathname !== '/appfolio' && history.pathname !== '/information_banners' ? 'paymentMarginWarning' : '')
  }, (getCompanySwitchInProgress() || !((_store$homeDashboardS36 = store.homeDashboardStore.getCurrentCompany) !== null && _store$homeDashboardS36 !== void 0 && (_store$homeDashboardS36 = _store$homeDashboardS36.portfolios) !== null && _store$homeDashboardS36 !== void 0 && _store$homeDashboardS36.length)) && /*#__PURE__*/React.createElement("div", {
    className: classes.emptyState
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.emptyStateContainer
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes.smSection, " ").concat(classes.emptyStateContainerItem)
  }, /*#__PURE__*/React.createElement("img", {
    src: welcomeToLivable,
    width: "278",
    height: "240",
    alt: "Welcome",
    title: "Welcome"
  })), /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes.smSection, " ").concat(classes.emptyStateContainerItem)
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h2"
  }, " ", t('portfolios_properties_page.welcome_to_livable')), (getCompanySwitchInProgress() || getPropertyDashboardLoadingStatus()) && /*#__PURE__*/React.createElement(LinearProgress, null)), !(getCompanySwitchInProgress() || getPropertyDashboardLoadingStatus()) && !store.company.companyFeatureStore.isAppfolio && /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes.xsSection, " ").concat(classes.emptyStateContainerItem)
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body1"
  }, t('portfolios_properties_page.first_property'))), !(getCompanySwitchInProgress() || getPropertyDashboardLoadingStatus()) && !store.company.companyFeatureStore.isAppfolio && /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes.xsSection, " ").concat(classes.emptyStateContainerItem, " ").concat(classes.emptyStateContainerItemAddPropertyButton)
  }, /*#__PURE__*/React.createElement(Button, {
    component: RouterLink,
    id: "addNewProperty",
    to: "/new_property",
    variant: "priority",
    'custom-attribute': '562-new-billing-module'
  }, /*#__PURE__*/React.createElement("span", {
    className: "actionText"
  }, " ", t('portfolios_properties_page.add_property')))))), !getCompanySwitchInProgress() && !!((_store$homeDashboardS37 = store.homeDashboardStore.getCurrentCompany) !== null && _store$homeDashboardS37 !== void 0 && (_store$homeDashboardS37 = _store$homeDashboardS37.portfolios) !== null && _store$homeDashboardS37 !== void 0 && _store$homeDashboardS37.length) && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: classes.allocationBodyPortfolioHeader
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.allocationBodyPortfolioHeaderTitle
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.allocationBodyPortfolioHeaderTitleName
  }, (_store$homeDashboardS38 = (_store$homeDashboardS39 = store.homeDashboardStore.getCurrentCompany) === null || _store$homeDashboardS39 === void 0 ? void 0 : _store$homeDashboardS39.name) !== null && _store$homeDashboardS38 !== void 0 ? _store$homeDashboardS38 : 'N/A'), /*#__PURE__*/React.createElement("div", {
    className: classes.allocationBodyPortfolioHeaderSubTitle
  }, (store.account.userProfile.isUserAdmin || store.account.userProfile.isUserSuperAdmin) && ((_store$homeDashboardS40 = store.homeDashboardStore.getCompanySelectorList.find(company => company.companyId === store.homeDashboardStore.getCurrentCompany.id)) === null || _store$homeDashboardS40 === void 0 ? void 0 : _store$homeDashboardS40.tagIds.length) > 0 && /*#__PURE__*/React.createElement("div", {
    className: classes.allocationBodyPortfolioHeaderTitleTags
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.allocationBodyPortfolioHeaderTitleTagsTitle
  }, "Tags:"), /*#__PURE__*/React.createElement("div", {
    className: classes.adminSelectItemsTags
  }, (_store$homeDashboardS41 = store.homeDashboardStore.getCompanySelectorList.find(company => company.companyId === store.homeDashboardStore.getCurrentCompany.id)) === null || _store$homeDashboardS41 === void 0 ? void 0 : _store$homeDashboardS41.tagIds.map(i => {
    if (store.tags.getTagById(i)) {
      return /*#__PURE__*/React.createElement("i", {
        style: {
          backgroundColor: store.tags.getTagById(i).color
        }
      }, store.tags.getTagById(i).name);
    }
  }))))), /*#__PURE__*/React.createElement("div", {
    className: classes.allocationBodyPortfolioHeaderSettings
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.allocationBodyPortfolioHeaderSettingsView
  }, /*#__PURE__*/React.createElement(BasicTooltip, {
    key: "shortcut-tooltip-switch-view-".concat((_store$homeDashboardS42 = store.homeDashboardStore) === null || _store$homeDashboardS42 === void 0 ? void 0 : _store$homeDashboardS42.enableShortcutsHintState),
    title: "Quick switch Alt+V or Option+V",
    placement: "top",
    open: ((_store$homeDashboardS43 = store.homeDashboardStore) === null || _store$homeDashboardS43 === void 0 ? void 0 : _store$homeDashboardS43.enableShortcutsHintState) || undefined
  }, /*#__PURE__*/React.createElement(ToggleButtonGroup, {
    value: store.homeDashboardStore.getCurrentCompany.companyDashboardViewType,
    onChange: handleViewType,
    exclusive: true,
    'custom-attribute': '564-new-billing-module'
  }, /*#__PURE__*/React.createElement(ToggleButton, {
    value: 'navigation-view',
    'custom-attribute': '565-new-billing-module-navigation-view'
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "menu-with-block"
  })), /*#__PURE__*/React.createElement(ToggleButton, {
    value: 'list-view',
    'custom-attribute': '565-new-billing-module-list-view'
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "menu-with-dots"
  }))))))), /*#__PURE__*/React.createElement("div", {
    className: classes.allocationBodyProperty
  }, (_store$homeDashboardS44 => {
    return ((_store$homeDashboardS44 = store.homeDashboardStore.getCurrentCompany) === null || _store$homeDashboardS44 === void 0 ? void 0 : _store$homeDashboardS44.companyDashboardViewType) === 'navigation-view';
  })() && /*#__PURE__*/React.createElement("div", {
    className: classes.allocationBodyPropertyNav
  }, /*#__PURE__*/React.createElement(SmartNav, {
    name: "Properties",
    isIcon: true,
    isPortfoliosNav: true,
    selectAllLabel: 'All properties',
    isFullPage: true,
    listItems: (_store$homeDashboardS45 = store.homeDashboardStore.getCurrentCompany) === null || _store$homeDashboardS45 === void 0 ? void 0 : _store$homeDashboardS45.portfolioNavOptions.filteredItems,
    isLoading: getCompanySwitchInProgress() || ((_store$portfolios$get5 = store.portfolios.getPortfoliosDashboardAsync.inProgressUnicIds) === null || _store$portfolios$get5 === void 0 ? void 0 : _store$portfolios$get5.includes(store.homeDashboardStore.companyAccessId)),
    selectActionCallback: smartNavSelectActionCallbackHandler,
    triggerDeleteModalOpen: value => {
      setIsDeletePortfolioModalOpen(value);
    },
    handleTabToBillingChange: () => {
      handleTabChange(undefined, "".concat(basePath, "/billing"));
    },
    handleShowCreateEditPortfolioTrigger: handleShowCreateEditPortfolioTrigger,
    handleShowManageAccessModal: handleShowManageAccessModal,
    handleShowEnrollModal: handleShowEnrollModal,
    setDeleteModalProps: setDeleteModalProps,
    openPropertyDetails: openPropertyDetails,
    triggerRefreshPortfolioData: triggerRefreshPortfolioData,
    handleRemovePortfolioFromProperty: handleRemovePortfolioFromProperty,
    handleOpenAssignPortfoliosToPropertyModal: handleOpenAssignPortfoliosToPropertyModal
  })), isPortfoliosDetails && /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes.allocationBodyPropertyContent, " ").concat(store.homeDashboardStore.getCurrentCompany.companyPropertiesNavOpen ? 'wider' : '', " ").concat(store.homeDashboardStore.getCurrentCompany.companyDashboardViewType === 'list-view' ? 'fullWidth' : '')
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.portfolioDetails
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes.portfolioDetailsHeader, " ").concat(isNewPortfolioDetails ? 'noBorderBottom' : '')
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.portfolioDetailsHeaderActions
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.portfolioDetailsHeaderName
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h3"
  }, (_store$homeDashboardS46 = store.homeDashboardStore.getCurrentPortfolio) === null || _store$homeDashboardS46 === void 0 ? void 0 : _store$homeDashboardS46.name), !isDefaultPortfoliosDetails && /*#__PURE__*/React.createElement(Button, {
    variant: "actionIcon",
    size: "small",
    onClick: event => {
      event.stopPropagation();
      event.preventDefault();
      handleShowCreateEditPortfolioTrigger(true, store.homeDashboardStore.getCurrentPortfolio);
    }
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "edit"
  }))), /*#__PURE__*/React.createElement("div", {
    className: classes.portfolioDetailsHeaderActionsList
  }, isDefaultPortfoliosDetails && !store.company.companyFeatureStore.isAppfolio && /*#__PURE__*/React.createElement(Button, {
    variant: "contained",
    size: "small",
    onClick: event => {
      event.stopPropagation();
      event.preventDefault();
      setIsIncompletedProperty(true);
      store.homeDashboardStore.selectActivePropertyId(null, false);
    }
  }, t('Create new property')), !isDefaultPortfoliosDetails && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(PortfolioHeaderSettingsTeammembersBlock, {
    items: (_store$homeDashboardS47 = store.homeDashboardStore.getCurrentPortfolio) === null || _store$homeDashboardS47 === void 0 ? void 0 : _store$homeDashboardS47.accessResponses
  }), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Button, {
    variant: "contained",
    size: "small",
    onClick: event => {
      var _store$homeDashboardS48, _store$homeDashboardS49, _store$homeDashboardS50;
      event.stopPropagation();
      event.preventDefault();
      const propertyPortfolioSet = (_store$homeDashboardS48 = store.homeDashboardStore.getCurrentCompany) === null || _store$homeDashboardS48 === void 0 ? void 0 : _store$homeDashboardS48.getAllUnicCompanyProperties.map(i => {
        return {
          propertyId: i.id,
          portfolioId: i.propertyPortfolioInfo.id
        };
      }).flat();
      (_store$homeDashboardS49 = store.homeDashboardStore.getCurrentCompany) === null || _store$homeDashboardS49 === void 0 || _store$homeDashboardS49.fetchPropertyInformationBatch(propertyPortfolioSet);
      (_store$homeDashboardS50 = store.homeDashboardStore.getCurrentCompany) === null || _store$homeDashboardS50 === void 0 || _store$homeDashboardS50.fetchBuildingsInformationBatch(propertyPortfolioSet);
      setIsAssignPropertiesToPortfolioModalOpen(true);
    }
  }, t('portfolios_properties_page.add_property'))), /*#__PURE__*/React.createElement("div", null, false && /*#__PURE__*/React.createElement(PortfoliosMenu, null), /*#__PURE__*/React.createElement(PortfolioActionsMenu, {
    portfolioId: (_store$homeDashboardS51 = store.homeDashboardStore.getCurrentPortfolio) === null || _store$homeDashboardS51 === void 0 ? void 0 : _store$homeDashboardS51.id,
    selectedPortfolio: store.homeDashboardStore.getCurrentPortfolio,
    menuTriggerExternal: /*#__PURE__*/React.createElement(Icon, {
      type: "dotdotdot"
    }),
    triggerDeleteModalOpen: value => {
      setIsDeletePortfolioModalOpen(value);
    },
    setDeleteModalProps: setDeleteModalProps,
    triggerRenameModalOpen: value => {
      handleShowCreateEditPortfolioTrigger(value);
    },
    setRenameModalProps: setRenameModalProps,
    handleShowManageAccessModal: handleShowManageAccessModal,
    selectActionCallback: smartNavSelectActionCallbackHandler
  }))))), !isNewPortfolioDetails && /*#__PURE__*/React.createElement("div", {
    className: classes.portfolioDetailsHeaderSearch
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.searchField
  }, /*#__PURE__*/React.createElement(InputWithIcon, {
    icon: /*#__PURE__*/React.createElement(Icon, {
      type: "search"
    })
  }, /*#__PURE__*/React.createElement(TextField, {
    variant: "outlined",
    fullWidth: true,
    placeholder: t('subscriptions.search_for_property'),
    value: portfolioDetailsSearchKey,
    onChange: event => {
      setPortfolioDetailsSearchKey(event.target.value);
    }
  }))))), !isNewPortfolioDetails && /*#__PURE__*/React.createElement("div", {
    className: classes.portfolioDetailsBody
  }, /*#__PURE__*/React.createElement(PortfoliosList, {
    portfolioDetailsSearchKey: portfolioDetailsSearchKey,
    selectProperty: id => {
      store.homeDashboardStore.selectActivePropertyId(id, false);
      navigate("/active_dashboard/".concat(COMPANY_ID, "/").concat(navPortfolioId, "/").concat(id, "/billing"));
    },
    openPropertyDetails: openPropertyDetails,
    handleShowEnrollModal: handleShowEnrollModal,
    handleOpenAssignPortfoliosToPropertyModal: handleOpenAssignPortfoliosToPropertyModal,
    selectActionCallback: smartNavSelectActionCallbackHandler,
    handleRemovePortfolioFromProperty: handleRemovePortfolioFromProperty
  })), isNewPortfolioDetails && /*#__PURE__*/React.createElement("div", {
    className: classes.newPortfolioBody
  }, /*#__PURE__*/React.createElement("img", {
    src: resumeFolder,
    width: "215",
    height: "160",
    alt: "icon message sent"
  }), /*#__PURE__*/React.createElement(Typography, {
    variant: "h3"
  }, "Portfolio is currently empty."), !store.company.companyFeatureStore.isAppfolio && /*#__PURE__*/React.createElement(Typography, {
    variant: "body1"
  }, "Let's get started with adding your first property"), /*#__PURE__*/React.createElement("div", {
    className: classes.flex
  }, !store.company.companyFeatureStore.isAppfolio && /*#__PURE__*/React.createElement(Button, {
    variant: "contained",
    onClick: event => {
      var _store$homeDashboardS52, _store$homeDashboardS53, _store$homeDashboardS54;
      event.stopPropagation();
      event.preventDefault();
      const propertyPortfolioSet = (_store$homeDashboardS52 = store.homeDashboardStore.getCurrentCompany) === null || _store$homeDashboardS52 === void 0 ? void 0 : _store$homeDashboardS52.getAllUnicCompanyProperties.map(i => {
        return {
          propertyId: i.id,
          portfolioId: i.propertyPortfolioInfo.id
        };
      }).flat();
      (_store$homeDashboardS53 = store.homeDashboardStore.getCurrentCompany) === null || _store$homeDashboardS53 === void 0 || _store$homeDashboardS53.fetchPropertyInformationBatch(propertyPortfolioSet);
      (_store$homeDashboardS54 = store.homeDashboardStore.getCurrentCompany) === null || _store$homeDashboardS54 === void 0 || _store$homeDashboardS54.fetchBuildingsInformationBatch(propertyPortfolioSet);
      setIsAssignPropertiesToPortfolioModalOpen(true);
    }
  }, "Add property"), /*#__PURE__*/React.createElement(Button, {
    variant: "text",
    onClick: event => {
      event.stopPropagation();
      event.preventDefault();
      handleShowManageAccessModal(true, null, store.homeDashboardStore.getCurrentPortfolio);
    }
  }, "Manage access"))))), !((_store$homeDashboardS55 = store.homeDashboardStore.getCurrentCompany) !== null && _store$homeDashboardS55 !== void 0 && (_store$homeDashboardS55 = _store$homeDashboardS55.getAllUnicCompanyProperties) !== null && _store$homeDashboardS55 !== void 0 && _store$homeDashboardS55.length) && store.homeDashboardStore.selectedPropertyId === 'all' && !isCurrentPropertyIncompleted && /*#__PURE__*/React.createElement("div", {
    className: classes.emptyState,
    style: {
      width: '100%',
      marginTop: '10rem'
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.emptyStateContainer
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes.smSection, " ").concat(classes.emptyStateContainerItem)
  }, /*#__PURE__*/React.createElement("img", {
    src: welcomeToLivable,
    width: "278",
    height: "240",
    alt: "Welcome",
    title: "Welcome"
  })), /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes.smSection, " ").concat(classes.emptyStateContainerItem)
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h2"
  }, ' ', t('portfolios_properties_page.welcome_to_livable')), (getCompanySwitchInProgress() || getPropertyDashboardLoadingStatus()) && /*#__PURE__*/React.createElement(LinearProgress, null)), !(getCompanySwitchInProgress() || getPropertyDashboardLoadingStatus()) && /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes.xsSection, " ").concat(classes.emptyStateContainerItem)
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body1"
  }, t('portfolios_properties_page.first_property'))), !(getCompanySwitchInProgress() || getPropertyDashboardLoadingStatus()) && /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes.xsSection, " ").concat(classes.emptyStateContainerItem, " ").concat(classes.emptyStateContainerItemAddPropertyButton)
  }, /*#__PURE__*/React.createElement(Button, {
    component: RouterLink,
    id: "addNewProperty",
    to: "/new_property",
    variant: "priority",
    'custom-attribute': '562-new-billing-module'
  }, /*#__PURE__*/React.createElement("span", {
    className: "actionText"
  }, " ", t('portfolios_properties_page.add_property')))))), !isPortfoliosDetails && (!!((_store$homeDashboardS56 = store.homeDashboardStore.getCurrentCompany) !== null && _store$homeDashboardS56 !== void 0 && (_store$homeDashboardS56 = _store$homeDashboardS56.getAllUnicCompanyProperties) !== null && _store$homeDashboardS56 !== void 0 && _store$homeDashboardS56.length) || isCurrentPropertyIncompleted) && /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes.allocationBodyPropertyContent, " ").concat(store.homeDashboardStore.getCurrentCompany.companyPropertiesNavOpen ? 'wider' : '', " ").concat(store.homeDashboardStore.getCurrentCompany.companyDashboardViewType === 'list-view' ? 'fullWidth' : '')
  }, store.account.featureFlagsStore.getIsFailedInvoicePaymentEnabled && store.homeDashboardStore.selectedPropertyId !== 'all' && ((_store$homeDashboardS57 = store.homeDashboardStore.getCurrentCompany.selectedPropertyDetails()) === null || _store$homeDashboardS57 === void 0 ? void 0 : _store$homeDashboardS57.details.paymentSetup.propertyPaymentMethodData.isInvoicePaymentFailed) && /*#__PURE__*/React.createElement("div", {
    className: classes.lapsedSubscriptionBlocking
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h4"
  }, "Subscription payment failed", /*#__PURE__*/React.createElement("br", null), "We were unable to process your subscription payment.", /*#__PURE__*/React.createElement("br", null), "To avoid any interruption to your service,", /*#__PURE__*/React.createElement("br", null), "please update your payment method (", (_store$homeDashboardS58 = store.homeDashboardStore.getCurrentCompany.selectedPropertyDetails()) === null || _store$homeDashboardS58 === void 0 ? void 0 : _store$homeDashboardS58.details.paymentSetup.propertyPaymentMethodData.brand, ' ', "ending in \u2022\u2022\u2022\u2022", ' ', (_store$homeDashboardS59 = store.homeDashboardStore.getCurrentCompany.selectedPropertyDetails()) === null || _store$homeDashboardS59 === void 0 ? void 0 : _store$homeDashboardS59.details.paymentSetup.propertyPaymentMethodData.last4, ") in Payment & Subscription Settings.", /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(Button, {
    variant: "contained",
    size: "small",
    onClick: () => navigate('/payments?tab=payment_information')
  }, "Update Payment Method"))), (store.homeDashboardStore.getCurrentCompany.companyDashboardViewType === 'navigation-view' || store.homeDashboardStore.selectedPropertyId !== 'all' && store.homeDashboardStore.getCurrentCompany.companyDashboardViewType === 'list-view') && /*#__PURE__*/React.createElement("div", {
    className: classes.allocationBodyPropertyHeader
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.allocationBodyPropertyHeaderTitle
  }, store.homeDashboardStore.selectedPropertyId !== 'all' && store.homeDashboardStore.getCurrentCompany.companyDashboardViewType === 'list-view' && /*#__PURE__*/React.createElement(Button, {
    variant: "actionButton",
    onClick: () => {
      if (store.homeDashboardStore.getCurrentCompany.companyDashboardViewType === 'list-view') {
        store.homeDashboardStore.selectActivePortfolioId('all');
        store.homeDashboardStore.selectActivePropertyId('all');
        handleTabChange(undefined, "/active_dashboard/".concat(COMPANY_ID, "/all/all"));
      }
    },
    'custom-attribute': '566-new-billing-module'
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "arrow-left"
  })), getCompanySwitchInProgress() || (_store$buildings$getB2 = store.buildings.getBuildingAsync.inProgressUnicIds) !== null && _store$buildings$getB2 !== void 0 && _store$buildings$getB2.includes(store.homeDashboardStore.selectedPropertyId) || !['all', 'new_property', null].includes(store.homeDashboardStore.selectedPropertyId) && !((_store$homeDashboardS60 = store.homeDashboardStore.getCurrentProperty) !== null && _store$homeDashboardS60 !== void 0 && (_store$homeDashboardS60 = _store$homeDashboardS60.buildingInformation) !== null && _store$homeDashboardS60 !== void 0 && _store$homeDashboardS60.buildingAddress) ? /*#__PURE__*/React.createElement(Skeleton, {
    variant: "text",
    animation: "wave",
    height: 24,
    width: 300
  }) : /*#__PURE__*/React.createElement(ExpandedTooltip, {
    type: "default",
    key: 'allocationBodyPropertyHeaderTitle',
    title: /*#__PURE__*/React.createElement("div", null, ((_store$homeDashboardS61 = store.homeDashboardStore.getCurrentProperty) === null || _store$homeDashboardS61 === void 0 || (_store$homeDashboardS61 = _store$homeDashboardS61.buildingInformation) === null || _store$homeDashboardS61 === void 0 ? void 0 : _store$homeDashboardS61.buildingAddress) || store.homeDashboardStore.selectedPropertyId === 'all' && 'All properties' || store.homeDashboardStore.selectedPropertyId === null && 'New Property', /*#__PURE__*/React.createElement("br", null), store.homeDashboardStore.selectedPropertyId !== 'all' && ((_store$homeDashboardS62 = store.homeDashboardStore) === null || _store$homeDashboardS62 === void 0 || (_store$homeDashboardS62 = _store$homeDashboardS62.getCurrentProperty) === null || _store$homeDashboardS62 === void 0 || (_store$homeDashboardS62 = _store$homeDashboardS62.propertyPortfolioInfo) === null || _store$homeDashboardS62 === void 0 ? void 0 : _store$homeDashboardS62.name)),
    placement: "top"
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      width: '100%'
    }
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h4",
    className: classes.overflowEllipsis
  }, ((_store$homeDashboardS63 = store.homeDashboardStore.getCurrentProperty) === null || _store$homeDashboardS63 === void 0 || (_store$homeDashboardS63 = _store$homeDashboardS63.buildingInformation) === null || _store$homeDashboardS63 === void 0 ? void 0 : _store$homeDashboardS63.buildingAddress) || store.homeDashboardStore.selectedPropertyId === 'all' && 'All properties' || store.homeDashboardStore.selectedPropertyId === null && 'New Property'), store.homeDashboardStore.selectedPropertyId !== 'all' && /*#__PURE__*/React.createElement(Typography, {
    variant: "h6",
    color: "light",
    className: classes.overflowEllipsis
  }, (_store$homeDashboardS64 = store.homeDashboardStore) === null || _store$homeDashboardS64 === void 0 || (_store$homeDashboardS64 = _store$homeDashboardS64.getCurrentProperty) === null || _store$homeDashboardS64 === void 0 || (_store$homeDashboardS64 = _store$homeDashboardS64.propertyPortfolioInfo) === null || _store$homeDashboardS64 === void 0 ? void 0 : _store$homeDashboardS64.name)))), (store.homeDashboardStore.selectedPropertyId !== 'all' && store.homeDashboardStore.getCurrentCompany.companyDashboardViewType === 'list-view' || store.homeDashboardStore.getCurrentCompany.companyDashboardViewType === 'navigation-view') && /*#__PURE__*/React.createElement("div", {
    className: classes.allocationBodyPropertyHeaderTabs
  }, !isCurrentPropertyIncompleted ? /*#__PURE__*/React.createElement(Tabs, {
    "aria-label": "tabs navigation",
    onChange: handleTabChange,
    position: "sticky",
    value: currentTab
  }, /*#__PURE__*/React.createElement(Tab, {
    label: t('dashboard_page.billing_tab'),
    value: "".concat(basePath, "/billing"),
    'custom-attribute': '567-new-billing-module'
  }), /*#__PURE__*/React.createElement(Tab, {
    label: t('dashboard_page.residents_tab'),
    value: "".concat(basePath, "/residents")
    // disabled={store.homeDashboardStore.selectedPropertyId === 'all'}
    ,
    'custom-attribute': '568-new-billing-module'
  }), store.homeDashboardStore.getCurrentProperty && /*#__PURE__*/React.createElement(Tab, {
    label: t('dashboard_page.details'),
    value: "".concat(basePath, "/details"),
    'custom-attribute': '569-new-billing-module'
  }), store.homeDashboardStore.getCurrentProperty && store.company.companyFeatureStore.isAppfolio && /*#__PURE__*/React.createElement(Tab, {
    label: t('general.appfolio_batches'),
    value: "".concat(basePath, "/appfolio-batches"),
    iconPosition: "end",
    icon: /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(ExpandedTooltip, {
      type: "grey",
      title: t('general.activity_log_info'),
      placement: "top"
    }, /*#__PURE__*/React.createElement(IconButton, null, /*#__PURE__*/React.createElement(Icon, {
      type: "info"
    })))),
    'custom-attribute': '570-new-billing-module'
  })) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Button, {
    variant: "text",
    size: "small",
    onClick: handleTriggerBack,
    disabled: isBackNextActionDisabled() || store.addNewProperty.activeStep === 'welcome'
  }, t('general.back')), /*#__PURE__*/React.createElement(Button, {
    variant: "contained",
    size: "small",
    onClick: handleTriggerNext,
    disabled: isBackNextActionDisabled()
  }, store.addNewProperty.activeStep === 'confirm' ? t('add_new_property_flow.activate_my_property') : t('general.next'))))), !isCurrentPropertyIncompleted && (currentTab !== "".concat(basePath, "/details") && store.homeDashboardStore.getCurrentCompany.companyDashboardViewType === 'navigation-view' || store.homeDashboardStore.selectedPropertyId !== 'all' && store.homeDashboardStore.getCurrentCompany.companyDashboardViewType === 'list-view') && /*#__PURE__*/React.createElement("div", {
    className: classes.allocationBodyContent
  }, /*#__PURE__*/React.createElement("div", null, (currentTab === "".concat(basePath, "/residents") || currentTab === "".concat(basePath, "/final-bills")) && /*#__PURE__*/React.createElement("div", {
    className: classes.allocationBodySettings
  }, currentTab === "".concat(basePath, "/residents") && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: classes.allocationBodySearch
  }, /*#__PURE__*/React.createElement(InputWithIcon, {
    icon: /*#__PURE__*/React.createElement(Icon, {
      type: "search"
    })
  }, /*#__PURE__*/React.createElement(TextField, {
    variant: "outlined",
    size: "small",
    fullWidth: true,
    placeholder: t('general.search'),
    value: residentTabSearchKey,
    onChange: handleResidentSearchKeyChange
  }))), /*#__PURE__*/React.createElement("div", {
    className: classes.allocationBodyStatusFilter
  }, /*#__PURE__*/React.createElement(SelectMenu, {
    label: "Residencies status",
    value: residentTabStatus,
    labelId: "status-selector-label",
    onChange: handleResidentsStatusChange
  }, Object.keys(RESIDENT_TAB_STATUSES_ENUM).map(key => /*#__PURE__*/React.createElement(MenuItem, {
    value: key
  }, t(key))))), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(ExpandedTooltip, {
    title: t("".concat((_store$homeDashboardS65 = store.homeDashboardStore.getCurrentCompany) !== null && _store$homeDashboardS65 !== void 0 && (_store$homeDashboardS65 = _store$homeDashboardS65.companyResidentsTabOptions) !== null && _store$homeDashboardS65 !== void 0 && _store$homeDashboardS65.includeEmptyUnitsFlag ? 'Exclude' : 'Include', " empty units")),
    key: 'nbm_include_empty_units_action_btn' + ((_store$homeDashboardS66 = store.homeDashboardStore) === null || _store$homeDashboardS66 === void 0 ? void 0 : _store$homeDashboardS66.enableShortcutsHintState),
    placement: "top",
    type: "info",
    open: ((_store$homeDashboardS67 = store.homeDashboardStore) === null || _store$homeDashboardS67 === void 0 ? void 0 : _store$homeDashboardS67.enableShortcutsHintState) || undefined
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "actionIcon",
    size: "small",
    onClick: event => {
      var _store$homeDashboardS68, _store$homeDashboardS69;
      event.stopPropagation();
      event.preventDefault();
      (_store$homeDashboardS68 = store.homeDashboardStore.getCurrentCompany) === null || _store$homeDashboardS68 === void 0 || (_store$homeDashboardS68 = _store$homeDashboardS68.companyResidentsTabOptions) === null || _store$homeDashboardS68 === void 0 || _store$homeDashboardS68.updateModel({
        includeEmptyUnitsFlag: !((_store$homeDashboardS69 = store.homeDashboardStore.getCurrentCompany) !== null && _store$homeDashboardS69 !== void 0 && (_store$homeDashboardS69 = _store$homeDashboardS69.companyResidentsTabOptions) !== null && _store$homeDashboardS69 !== void 0 && _store$homeDashboardS69.includeEmptyUnitsFlag)
      });
    },
    state: (_store$homeDashboardS70 = store.homeDashboardStore.getCurrentCompany) !== null && _store$homeDashboardS70 !== void 0 && (_store$homeDashboardS70 = _store$homeDashboardS70.companyResidentsTabOptions) !== null && _store$homeDashboardS70 !== void 0 && _store$homeDashboardS70.includeEmptyUnitsFlag ? 'active' : undefined
  }, /*#__PURE__*/React.createElement(Icon, {
    type: (_store$homeDashboardS71 = store.homeDashboardStore.getCurrentCompany) !== null && _store$homeDashboardS71 !== void 0 && (_store$homeDashboardS71 = _store$homeDashboardS71.companyResidentsTabOptions) !== null && _store$homeDashboardS71 !== void 0 && _store$homeDashboardS71.includeEmptyUnitsFlag ? 'plus' : 'subtract'
  })))), !store.company.companyFeatureStore.isAppfolio && /*#__PURE__*/React.createElement("div", {
    className: classes.allocationBodyActionFilter
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "contained",
    size: "small",
    onClick: event => {
      event.preventDefault();
      event.stopPropagation();
      handleShowEnrollModal(true);
    },
    'custom-attribute': '571-new-billing-module'
  }, "Enroll resident"))), currentTab === "".concat(basePath, "/final-bills") && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: classes.allocationBodySearch
  }, /*#__PURE__*/React.createElement(InputWithIcon, {
    icon: /*#__PURE__*/React.createElement(Icon, {
      type: "search"
    })
  }, /*#__PURE__*/React.createElement(TextField, {
    variant: "outlined",
    size: "small",
    fullWidth: true,
    placeholder: t('general.search')
  }))), /*#__PURE__*/React.createElement("div", {
    className: classes.allocationBodyStatusFilter
  }, /*#__PURE__*/React.createElement(SelectMenu, {
    label: "Status",
    value: status,
    labelId: "status-selector-label",
    onChange: handleStatusChange
  }, /*#__PURE__*/React.createElement(MenuItem, {
    value: 'all'
  }, "All"), /*#__PURE__*/React.createElement(MenuItem, {
    value: 'one'
  }, "One"), /*#__PURE__*/React.createElement(MenuItem, {
    value: 'two'
  }, "Two"))), /*#__PURE__*/React.createElement("div", {
    className: classes.allocationBodyActionFilter
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "text",
    size: "small",
    'custom-attribute': '572-new-billing-module'
  }, "Send all without review")))), currentTab === "".concat(basePath, "/appfolio-batches") && /*#__PURE__*/React.createElement(AppfolioBatches, null)), (store.homeDashboardStore.getCurrentCompany.companyDashboardViewType === 'navigation-view' || currentTab !== "".concat(basePath, "/details") && store.homeDashboardStore.getCurrentCompany.companyDashboardViewType === 'list-view') && /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes.allocationBodyList, " ").concat(currentTab === "".concat(basePath, "/residents") ? 'residents' : currentTab === "".concat(basePath, "/details") ? 'details' : currentTab === "".concat(basePath, "/appfolio-batches") ? 'appfolio-batches' : 'billing', " ").concat(store.payment.failedPaymentMethods && store.payment.warningPaymentMethods && history.pathname !== '/admin' && history.pathname !== '/appfolio' && history.pathname !== '/information_banners' ? 'paymentMarginWarningBoth' : (store.payment.failedPaymentMethods || store.payment.warningPaymentMethods) && history.pathname !== '/admin' && history.pathname !== '/appfolio' && history.pathname !== '/information_banners' ? 'paymentMarginWarning' : '')
  }, currentTab === "".concat(basePath, "/billing") && /*#__PURE__*/React.createElement(BillingTab, null), currentTab === "".concat(basePath, "/residents") && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ResidentsTabContent, {
    searchString: residentTabSearchKey,
    searchStatus: RESIDENT_TAB_STATUSES_ENUM[residentTabStatus]
  })), currentTab === "".concat(basePath, "/final-bills") && /*#__PURE__*/React.createElement("div", {
    className: classes.accordionBody
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.accordionBodyList
  }, [1, 2, 3, 4, 5, 6, 7, 8, 9].map(i => /*#__PURE__*/React.createElement("div", {
    className: classes.allocationItem,
    key: i
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.accordionBodyItem
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.accordionBodyItemInfo
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.accordionBodyItemInfoIcon
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "paper-dollar"
  })), /*#__PURE__*/React.createElement("div", {
    className: classes.accordionBodyItemInfoDetails
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("b", null, "Bruce Swaniawski, Unit 12 final bill"), /*#__PURE__*/React.createElement(Chip, {
    label: "Ready to be sent",
    variant: "success"
  }), /*#__PURE__*/React.createElement(Chip, {
    label: "Overdue",
    variant: "warning"
  })), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("i", null, "45635 Pueblo Rd, Indian Wells, California 92210, USA")), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("i", null, "move-out on: ", /*#__PURE__*/React.createElement("b", null, "02/25/2024")), /*#__PURE__*/React.createElement("i", null, "Total charge: ", /*#__PURE__*/React.createElement("b", null, "$207.00"))))), /*#__PURE__*/React.createElement("div", {
    className: classes.accordionBodyItemControl
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Button, {
    variant: "contained",
    size: "small",
    'custom-attribute': '573-new-billing-module'
  }, "Send without review")), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Button, {
    variant: "text",
    size: "small",
    'custom-attribute': '574-new-billing-module'
  }, "Review")))))))))), !isCurrentPropertyIncompleted && (currentTab === "".concat(basePath, "/details") && store.homeDashboardStore.getCurrentCompany.companyDashboardViewType === 'navigation-view' || currentTab === "".concat(basePath, "/details") && store.homeDashboardStore.getCurrentCompany.companyDashboardViewType === 'list-view' && store.homeDashboardStore.selectedPropertyId !== 'all') && /*#__PURE__*/React.createElement("div", {
    className: classes.allocationBodyDetailed
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes.allocationBodyDetailedWrapper, " ").concat(store.payment.failedPaymentMethods && store.payment.warningPaymentMethods && history.pathname !== '/admin' && history.pathname !== '/appfolio' && history.pathname !== '/information_banners' ? 'paymentMarginWarningBoth' : (store.payment.failedPaymentMethods || store.payment.warningPaymentMethods) && history.pathname !== '/admin' && history.pathname !== '/appfolio' && history.pathname !== '/information_banners' ? 'paymentMarginWarning' : '')
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.allocationBodyDetailedWrapperHeader
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.allocationBodyDetailedWrapperHeaderDetail
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.allocationBodyDetailedWrapperHeaderTitle
  }, t('add_new_property_flow.property_details'))), /*#__PURE__*/React.createElement("div", {
    className: classes.allocationBodyDetailedWrapperHeaderControllers
  }, store.account.featureFlagsStore.getIsMultiAccountAccessEnabled && /*#__PURE__*/React.createElement("div", null, (_store$homeDashboardS72 = store.homeDashboardStore.getCurrentProperty) === null || _store$homeDashboardS72 === void 0 ? void 0 : _store$homeDashboardS72.accessResponses.map(item => {
    return /*#__PURE__*/React.createElement("div", {
      className: classes.userCircles
    }, /*#__PURE__*/React.createElement(BasicTooltip, {
      title: "".concat(item.firstName, " ").concat(item.lastName),
      placement: "top"
    }, item.firstName.toUpperCase().charAt(0)));
  })), /*#__PURE__*/React.createElement("div", {
    className: classes.allocationBodyDetailedWrapperHeaderControllerMenu
  }, /*#__PURE__*/React.createElement(PropertyActionsMenu, {
    id: (_store$homeDashboardS73 = store.homeDashboardStore) === null || _store$homeDashboardS73 === void 0 || (_store$homeDashboardS73 = _store$homeDashboardS73.getCurrentProperty) === null || _store$homeDashboardS73 === void 0 ? void 0 : _store$homeDashboardS73.id,
    isActive: ((_store$homeDashboardS74 = store.homeDashboardStore) === null || _store$homeDashboardS74 === void 0 || (_store$homeDashboardS74 = _store$homeDashboardS74.getCurrentProperty) === null || _store$homeDashboardS74 === void 0 || (_store$homeDashboardS74 = _store$homeDashboardS74.dashboard) === null || _store$homeDashboardS74 === void 0 ? void 0 : _store$homeDashboardS74.propertyStatus) === PROPERTY_STATUS_ENUM.Active,
    isInDefaultPortfolio: (_store$homeDashboardS75 = store.homeDashboardStore) === null || _store$homeDashboardS75 === void 0 || (_store$homeDashboardS75 = _store$homeDashboardS75.getCurrentProperty) === null || _store$homeDashboardS75 === void 0 || (_store$homeDashboardS75 = _store$homeDashboardS75.propertyPortfolioInfo) === null || _store$homeDashboardS75 === void 0 ? void 0 : _store$homeDashboardS75.isDefault,
    openPropertyDetails: openPropertyDetails,
    handleShowEnrollModal: () => {
      var _store$homeDashboardS76;
      handleShowEnrollModal(true, {
        portfolioId: (_store$homeDashboardS76 = store.homeDashboardStore.getCurrentProperty.propertyPortfolioInfo) === null || _store$homeDashboardS76 === void 0 ? void 0 : _store$homeDashboardS76.id,
        propertyId: store.homeDashboardStore.getCurrentProperty.id,
        enablePortfolioSelect: false,
        enablePropertySelect: false
      });
    },
    hideEditPropertyOption: true,
    handleOpenAssignPortfoliosToPropertyModal: () => {
      var _store$homeDashboardS77;
      return handleOpenAssignPortfoliosToPropertyModal({
        property: (_store$homeDashboardS77 = store.homeDashboardStore) === null || _store$homeDashboardS77 === void 0 ? void 0 : _store$homeDashboardS77.getCurrentProperty
      });
    },
    menuTriggerExternal: /*#__PURE__*/React.createElement(Icon, {
      type: "dotdotdot",
      'custom-attribute': '576-new-billing-module'
    }),
    changeActiveProperty: () => {
      // setSelectedTab('billing');
    },
    handleRemovePortfolioFromProperty: () => {
      var _store$homeDashboardS78, _store$homeDashboardS79;
      return handleRemovePortfolioFromProperty({
        payload: (_store$homeDashboardS78 = store.homeDashboardStore) === null || _store$homeDashboardS78 === void 0 ? void 0 : _store$homeDashboardS78.getCurrentProperty,
        portfolioId: (_store$homeDashboardS79 = store.homeDashboardStore.getCurrentProperty) === null || _store$homeDashboardS79 === void 0 || (_store$homeDashboardS79 = _store$homeDashboardS79.propertyPortfolioInfo) === null || _store$homeDashboardS79 === void 0 ? void 0 : _store$homeDashboardS79.id
      });
    }
  })))), /*#__PURE__*/React.createElement("div", {
    className: classes.allocationBodyDetailedWrapperContent
  }, !store.company.companyFeatureStore.isAppfolio && /*#__PURE__*/React.createElement("div", {
    className: classes.allocationBodyDetailedWrapperContentItem
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.allocationBodyDetailedWrapperContentItemTitle
  }, "Highlights"), /*#__PURE__*/React.createElement("div", {
    className: classes.allocationBodyDetailedWrapperContentItemBody
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.infoBlocks
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes.infoBlock, " success")
  }, getCompanySwitchInProgress() || getPropertyDashboardLoadingStatus((_store$homeDashboardS80 = store.homeDashboardStore.getCurrentProperty) === null || _store$homeDashboardS80 === void 0 ? void 0 : _store$homeDashboardS80.id) ? /*#__PURE__*/React.createElement(Skeleton, {
    variant: "text",
    animation: "wave"
    // sx={{ bgcolor: 'inherit' }}
    ,
    height: 24,
    width: 90
  }) : /*#__PURE__*/React.createElement("b", null, "$", Number((_store$homeDashboardS81 = store.homeDashboardStore.getCurrentProperty) === null || _store$homeDashboardS81 === void 0 || (_store$homeDashboardS81 = _store$homeDashboardS81.dashboard) === null || _store$homeDashboardS81 === void 0 ? void 0 : _store$homeDashboardS81.distributionToDate).toFixed(2)), /*#__PURE__*/React.createElement("b", null, "Total reimbursed")), /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes.infoBlock, " success")
  }, getCompanySwitchInProgress() || getPropertyDashboardLoadingStatus((_store$homeDashboardS82 = store.homeDashboardStore.getCurrentProperty) === null || _store$homeDashboardS82 === void 0 ? void 0 : _store$homeDashboardS82.id) ? /*#__PURE__*/React.createElement(Skeleton, {
    variant: "text",
    animation: "wave"
    // sx={{ bgcolor: 'inherit' }}
    ,
    height: 24,
    width: 90
  }) : /*#__PURE__*/React.createElement("b", null, "$", Number((_store$homeDashboardS83 = store.homeDashboardStore.getCurrentProperty) === null || _store$homeDashboardS83 === void 0 || (_store$homeDashboardS83 = _store$homeDashboardS83.dashboard) === null || _store$homeDashboardS83 === void 0 ? void 0 : _store$homeDashboardS83.distributionForCurrentMonth).toFixed(2)), /*#__PURE__*/React.createElement("b", null, "Reimbursed", ' ', moment(store.properties.serverBusinessDateOnly).set('month', ((_store$homeDashboardS84 = store.homeDashboardStore.getCurrentProperty) === null || _store$homeDashboardS84 === void 0 || (_store$homeDashboardS84 = _store$homeDashboardS84.dashboard) === null || _store$homeDashboardS84 === void 0 ? void 0 : _store$homeDashboardS84.previousMonth) - 1).format('MMMM'))), /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes.infoBlock, " error")
  }, getCompanySwitchInProgress() || getPropertyDashboardLoadingStatus((_store$homeDashboardS85 = store.homeDashboardStore.getCurrentProperty) === null || _store$homeDashboardS85 === void 0 ? void 0 : _store$homeDashboardS85.id) ? /*#__PURE__*/React.createElement(Skeleton, {
    variant: "text",
    animation: "wave"
    // sx={{ bgcolor: 'inherit' }}
    ,
    height: 24,
    width: 90
  }) : /*#__PURE__*/React.createElement("b", null, "$", Number((_store$homeDashboardS86 = store.homeDashboardStore.getCurrentProperty) === null || _store$homeDashboardS86 === void 0 || (_store$homeDashboardS86 = _store$homeDashboardS86.dashboard) === null || _store$homeDashboardS86 === void 0 ? void 0 : _store$homeDashboardS86.accountsReceivable).toFixed(2)), /*#__PURE__*/React.createElement("b", null, "Accounts Receivable")), /*#__PURE__*/React.createElement("div", {
    className: classes.infoBlock
  }, getCompanySwitchInProgress() || getPropertyDashboardLoadingStatus((_store$homeDashboardS87 = store.homeDashboardStore.getCurrentProperty) === null || _store$homeDashboardS87 === void 0 ? void 0 : _store$homeDashboardS87.id) ? /*#__PURE__*/React.createElement(Skeleton, {
    variant: "text",
    animation: "wave",
    height: 24,
    width: 90
  }) : /*#__PURE__*/React.createElement("b", null, (_store$homeDashboardS88 = store.homeDashboardStore.getCurrentProperty) === null || _store$homeDashboardS88 === void 0 || (_store$homeDashboardS88 = _store$homeDashboardS88.dashboard) === null || _store$homeDashboardS88 === void 0 ? void 0 : _store$homeDashboardS88.unitsEnrolled, "/", (_store$homeDashboardS89 = store.homeDashboardStore.getCurrentProperty) === null || _store$homeDashboardS89 === void 0 || (_store$homeDashboardS89 = _store$homeDashboardS89.dashboard) === null || _store$homeDashboardS89 === void 0 ? void 0 : _store$homeDashboardS89.unitsTotal), /*#__PURE__*/React.createElement("b", null, "Enrolled units"))))), store.account.featureFlagsStore.getIsMultiAccountAccessEnabled && /*#__PURE__*/React.createElement("div", {
    className: classes.allocationBodyDetailedWrapperContentItem
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.allocationBodyDetailedWrapperContentItemTitle
  }, t('portfolios_properties_page.portfolios')), /*#__PURE__*/React.createElement(Grid, {
    container: true,
    direction: 'row',
    columnSpacing: 2,
    rowSpacing: 2
  }, /*#__PURE__*/React.createElement(PropertyPortfolioTagsBlock, {
    addPortfolioEnabled: true,
    propertyAddress: (_store$homeDashboardS90 = store.homeDashboardStore.getCurrentProperty) === null || _store$homeDashboardS90 === void 0 || (_store$homeDashboardS90 = _store$homeDashboardS90.propertyInformation) === null || _store$homeDashboardS90 === void 0 || (_store$homeDashboardS90 = _store$homeDashboardS90.address) === null || _store$homeDashboardS90 === void 0 ? void 0 : _store$homeDashboardS90.addressString,
    propertySelectedPortfolioListIds: (_store$homeDashboardS91 = store.homeDashboardStore.getCurrentProperty) === null || _store$homeDashboardS91 === void 0 || (_store$homeDashboardS91 = _store$homeDashboardS91.propertyInformation) === null || _store$homeDashboardS91 === void 0 ? void 0 : _store$homeDashboardS91.portfolioIds,
    updateSelectedPortfoliosCallBack: data => {
      var _store$homeDashboardS92;
      store.portfolios.editPropertyPortfoliosRelationshipAsync.run({
        propertyId: (_store$homeDashboardS92 = store.homeDashboardStore) === null || _store$homeDashboardS92 === void 0 || (_store$homeDashboardS92 = _store$homeDashboardS92.getCurrentProperty) === null || _store$homeDashboardS92 === void 0 ? void 0 : _store$homeDashboardS92.id,
        portfolioIds: data.filter(propertyPortfolioId => {
          var _store$homeDashboardS93;
          return ((_store$homeDashboardS93 = store.homeDashboardStore.getCurrentCompany) === null || _store$homeDashboardS93 === void 0 || (_store$homeDashboardS93 = _store$homeDashboardS93.companyPortfolioDataDetails(propertyPortfolioId)) === null || _store$homeDashboardS93 === void 0 ? void 0 : _store$homeDashboardS93.isDefault) !== true;
        })
      }).then(resp => {
        if (resp !== null && resp !== void 0 && resp.isSuccessful) {
          toast('success', {
            body: ['Successfully updated!']
          });
        }
        fetchPropertyInformation();
      });
    },
    getPortfolioDetailsHandler: id => {
      var _store$homeDashboardS94;
      return (_store$homeDashboardS94 = store.homeDashboardStore.getCurrentCompany) === null || _store$homeDashboardS94 === void 0 ? void 0 : _store$homeDashboardS94.companyPortfolioDataDetails(id);
    },
    removePortfolioActionHandler: portfolioId => {
      var _store$homeDashboardS95;
      return removePortfolioActionHandler((_store$homeDashboardS95 = store.homeDashboardStore) === null || _store$homeDashboardS95 === void 0 ? void 0 : _store$homeDashboardS95.getCurrentProperty, portfolioId);
    },
    isLoading: ((_store$properties$get5 = store.properties.getPropertyAsync.inProgressUnicIds) === null || _store$properties$get5 === void 0 ? void 0 : _store$properties$get5.includes(store.homeDashboardStore.selectedPropertyId)) || store.portfolios.getExistingPortfoliosAsync.inProgress || ((_store$portfolios$edi = store.portfolios.editPropertyPortfoliosRelationshipAsync) === null || _store$portfolios$edi === void 0 ? void 0 : _store$portfolios$edi.inProgress) || !((_store$homeDashboardS96 = store.homeDashboardStore.getCurrentProperty) !== null && _store$homeDashboardS96 !== void 0 && (_store$homeDashboardS96 = _store$homeDashboardS96.propertyInformation) !== null && _store$homeDashboardS96 !== void 0 && _store$homeDashboardS96.portfolioIds) || ((_store$homeDashboardS97 = store.homeDashboardStore.getCurrentProperty) === null || _store$homeDashboardS97 === void 0 || (_store$homeDashboardS97 = _store$homeDashboardS97.propertyInformation) === null || _store$homeDashboardS97 === void 0 || (_store$homeDashboardS97 = _store$homeDashboardS97.portfolioIds) === null || _store$homeDashboardS97 === void 0 ? void 0 : _store$homeDashboardS97.length) === 0
  }))), /*#__PURE__*/React.createElement("div", {
    className: classes.allocationBodyDetailedWrapperContentItem
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.allocationBodyDetailedWrapperContentItemTitle
  }, t('add_new_property_flow.utilities')), /*#__PURE__*/React.createElement("div", {
    className: classes.allocationBodyDetailedWrapperContentItemBody
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    columnSpacing: 8,
    rowSpacing: 8
  }, getCompanySwitchInProgress() || (_store$propertyUtilit7 = store.propertyUtility.getPropertyUtilitiesByPropertyAsync.inProgressUnicIds) !== null && _store$propertyUtilit7 !== void 0 && _store$propertyUtilit7.includes(store.homeDashboardStore.getCurrentProperty.id) || (_store$properties$get6 = store.properties.getPropertyUtilityProvidersV3Async.inProgressUnicIds) !== null && _store$properties$get6 !== void 0 && _store$properties$get6.includes(store.homeDashboardStore.getCurrentProperty.id) || (_store$properties$get7 = store.properties.getPropertyUtilityProvidersV3Async.inProgressUnicIds) !== null && _store$properties$get7 !== void 0 && _store$properties$get7.includes(store.homeDashboardStore.getCurrentProperty.id) ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React.createElement(DetailedItem, {
    icon: true,
    isDummyLoadingState: true
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React.createElement(DetailedItem, {
    icon: true,
    isDummyLoadingState: true
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React.createElement(DetailedItem, {
    icon: true,
    isDummyLoadingState: true
  }))) : /*#__PURE__*/React.createElement(React.Fragment, null, (_store$homeDashboardS98 = store.homeDashboardStore.getCurrentCompany.selectedPropertyDetails()) === null || _store$homeDashboardS98 === void 0 || (_store$homeDashboardS98 = _store$homeDashboardS98.details[store.account.featureFlagsStore.getIsBillingTemplatesEnabled ? 'billingTemplatesList' : 'utilityTemplatesList']) === null || _store$homeDashboardS98 === void 0 ? void 0 : _store$homeDashboardS98.map(template => {
    return /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 6
    }, /*#__PURE__*/React.createElement(DetailedItem, {
      name: template.utilityName || 'N/a',
      subname: template.provider.utilityProviderName,
      caption: "Allocated by: ".concat(CONSTANTS.ALLOCATION_METHODS[template.allocationMethod]),
      icon: template.utilityName || 'N/a',
      handleOpenUtilityModal: () => {
        var _store$homeDashboardS99;
        (_store$homeDashboardS99 = store.homeDashboardStore.getCurrentCompany.selectedPropertyDetails()) === null || _store$homeDashboardS99 === void 0 || _store$homeDashboardS99.details[store.account.featureFlagsStore.getIsBillingTemplatesEnabled ? 'setBillingTemplateModalForm' : 'setUtilityTemplateModalForm'](template);
        handleOpenUtilityModal();
      },
      handleRemoveUtility: () => {
        deletePropertyUtility({
          propertyUtilityId: template === null || template === void 0 ? void 0 : template.propertyUtilityId,
          urjanetCredentialsForProvider: undefined,
          utilityName: template.utilityName,
          utilityId: template === null || template === void 0 ? void 0 : template.id,
          providerName: template.provider.utilityProviderName
        });
      },
      handleAutoBilling: () => {
        console.log('handleAutoBilling');
      },
      isDummyLoadingState: store.account.featureFlagsStore.getIsBillingTemplatesEnabled ? getBillingItemLoadingStatus(template.propertyUtilityId) : getUtilityItemLoadingStatus(template.id)
    }));
  }), (store.account.featureFlagsStore.getIsBillingTemplatesEnabled ? getBillingItemLoadingStatus('NEW_TEMPLATE') : getUtilityItemLoadingStatus('NEW_UTILITY_TEMPLATE')) && /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React.createElement(DetailedItem, {
    icon: true,
    isDummyLoadingState: true
  }))))), /*#__PURE__*/React.createElement("div", {
    className: classes.allocationBodyDetailedWrapperContentItemFooter
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "actionButton",
    onClick: event => {
      event.stopPropagation();
      event.preventDefault();
      store.homeDashboardStore.getCurrentCompany.selectedPropertyDetails().details[store.account.featureFlagsStore.getIsBillingTemplatesEnabled ? 'setBillingTemplateModalForm' : 'setUtilityTemplateModalForm']({});
      handleOpenUtilityModal();
    },
    'custom-attribute': '577-new-billing-module'
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "plus"
  }), /*#__PURE__*/React.createElement("span", null, "Add utility")))), /*#__PURE__*/React.createElement("div", {
    className: classes.allocationBodyDetailedWrapperContentItem
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.allocationBodyDetailedWrapperContentItemTitle
  }, "Common Area Amenities", /*#__PURE__*/React.createElement(BasicTooltip, {
    placement: "top",
    title: t('add_new_property_flow.amenities_cad_help_tooltip')
  }, /*#__PURE__*/React.createElement(Button, {
    className: classes.infoButton,
    onClick: () => window.open('https://pro.livable.com/knowledge', '_blank'),
    size: "small",
    variant: "actionIcon",
    'custom-attribute': '698-new-billing-module'
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "question",
    state: "info"
  })))), /*#__PURE__*/React.createElement("div", {
    className: classes.allocationBodyDetailedWrapperContentItemBody
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    columnSpacing: 8,
    rowSpacing: 8
  }, getCompanySwitchInProgress() || (_store$utilityProvide10 = store.utilityProviders.getPropertyCommonAreaAmenitiesAsync.inProgressUnicIds) !== null && _store$utilityProvide10 !== void 0 && _store$utilityProvide10.includes(store.homeDashboardStore.getCurrentProperty.id) ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 4
  }, /*#__PURE__*/React.createElement(DetailedItem, {
    icon: true,
    isDummyLoadingState: true
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 4
  }, /*#__PURE__*/React.createElement(DetailedItem, {
    icon: true,
    isDummyLoadingState: true
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 4
  }, /*#__PURE__*/React.createElement(DetailedItem, {
    icon: true,
    isDummyLoadingState: true
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 4
  }, /*#__PURE__*/React.createElement(DetailedItem, {
    icon: true,
    isDummyLoadingState: true
  }))) : /*#__PURE__*/React.createElement(React.Fragment, null, (_store$homeDashboardS100 = store.homeDashboardStore.getCurrentCompany.selectedPropertyDetails()) === null || _store$homeDashboardS100 === void 0 || (_store$homeDashboardS100 = _store$homeDashboardS100.details) === null || _store$homeDashboardS100 === void 0 ? void 0 : _store$homeDashboardS100.amenities.map(amenityItem => {
    var _amenityItem$amenityD, _amenityItem$amenityD2, _amenityItem$amenityD3;
    return /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 4
    }, /*#__PURE__*/React.createElement(DetailedItem, {
      id: amenityItem.id,
      key: amenityItem.id,
      type: 'amenity',
      disableAmenityEdit: true,
      name: (amenityItem === null || amenityItem === void 0 || (_amenityItem$amenityD = amenityItem.amenityDetails) === null || _amenityItem$amenityD === void 0 ? void 0 : _amenityItem$amenityD.name) || 'N/a',
      caption: amenityItem === null || amenityItem === void 0 || (_amenityItem$amenityD2 = amenityItem.amenityDetails) === null || _amenityItem$amenityD2 === void 0 ? void 0 : _amenityItem$amenityD2.selectedOption.name,
      icon: (amenityItem === null || amenityItem === void 0 || (_amenityItem$amenityD3 = amenityItem.amenityDetails) === null || _amenityItem$amenityD3 === void 0 ? void 0 : _amenityItem$amenityD3.name) || 'N/a',
      handleOpenAmenityModal: () => handleOpenAmenityModal({
        amenityModalPropsInput: amenityItem
      }),
      handleRemoveAmenityModal: () => {
        deletePropertyAmenity({
          amenityObj: amenityItem
        });
      },
      isDummyLoadingState: getAmenityItemLoadingStatus(amenityItem.id)
    }));
  }), getAmenityItemLoadingStatus('NEW_AMENITY') && /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 4
  }, /*#__PURE__*/React.createElement(DetailedItem, {
    icon: true,
    isDummyLoadingState: true
  }))))), /*#__PURE__*/React.createElement("div", {
    className: classes.allocationBodyDetailedWrapperContentItemFooter
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "actionButton",
    onClick: event => {
      event.stopPropagation();
      event.preventDefault();
      handleOpenAmenityModal({
        amenityModalPropsInput: {}
      });
      // store.homeDashboardStore.getCurrentCompany
      //   .selectedPropertyDetails()
      //   .details.setBillingTemplateModalForm({});
      // handleOpenUtilityModal();
    },
    'custom-attribute': '578-new-billing-module'
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "plus"
  }), /*#__PURE__*/React.createElement("span", null, t('add_new_property_flow.add_common_area_amenity'))))), store.company.companyFeatureStore.isAppfolio && /*#__PURE__*/React.createElement("div", {
    className: classes.allocationBodyDetailedWrapperContentItem
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.allocationBodyDetailedWrapperContentItemTitle
  }, "General ledger(GL) accounts"), (store.credentials.getGLAccountsAsync.inProgress || store.credentials.getAppfolioPropertiesAsync.inProgress) && /*#__PURE__*/React.createElement(Grid, {
    container: true,
    columnSpacing: 8,
    rowSpacing: 8
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React.createElement(Skeleton, {
    variant: "text",
    animation: "wave",
    height: 48,
    width: '100%'
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React.createElement(Skeleton, {
    variant: "text",
    animation: "wave",
    height: 48,
    width: '100%'
  }))), !(store.credentials.getGLAccountsAsync.inProgress || store.credentials.getAppfolioPropertiesAsync.inProgress) && /*#__PURE__*/React.createElement("div", {
    className: classes.allocationBodyDetailedWrapperContentItemBody
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    columnSpacing: 8,
    rowSpacing: 8
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.allocationBodyDetailedWrapperContentItemSubTitle
  }, "Admin fee GL account"), ((_store$credentials$pa = store.credentials.patchAppfolioPropertiesAsync) === null || _store$credentials$pa === void 0 || (_store$credentials$pa = _store$credentials$pa.inProgressUnicIds) === null || _store$credentials$pa === void 0 ? void 0 : _store$credentials$pa.includes('adminFeeGlAccountExternalId')) && /*#__PURE__*/React.createElement(Skeleton, {
    variant: "text",
    animation: "wave",
    height: 48,
    width: '100%'
  }), !((_store$credentials$pa2 = store.credentials.patchAppfolioPropertiesAsync) !== null && _store$credentials$pa2 !== void 0 && (_store$credentials$pa2 = _store$credentials$pa2.inProgressUnicIds) !== null && _store$credentials$pa2 !== void 0 && _store$credentials$pa2.includes('adminFeeGlAccountExternalId')) && /*#__PURE__*/React.createElement(SelectMenu, {
    enableSearch: true,
    id: "admin-gl-selector",
    labelId: "admin-gl-selector-label",
    label: (_store$homeDashboardS101 = store.homeDashboardStore.getCurrentCompany.selectedPropertyDetails()) !== null && _store$homeDashboardS101 !== void 0 && (_store$homeDashboardS101 = _store$homeDashboardS101.details) !== null && _store$homeDashboardS101 !== void 0 && (_store$homeDashboardS101 = _store$homeDashboardS101.glCodeSetup) !== null && _store$homeDashboardS101 !== void 0 && _store$homeDashboardS101.adminFeeGlAccountExternalId ? null : 'Select admin fee GL account',
    disabled: ((_store$homeDashboardS102 = store.homeDashboardStore.getCurrentCompany.selectedPropertyDetails()) === null || _store$homeDashboardS102 === void 0 || (_store$homeDashboardS102 = _store$homeDashboardS102.details) === null || _store$homeDashboardS102 === void 0 || (_store$homeDashboardS102 = _store$homeDashboardS102.glCodeSetup) === null || _store$homeDashboardS102 === void 0 ? void 0 : _store$homeDashboardS102.glAccountsStored.length) === 0,
    onSearch: handleGlSearch,
    onCloseExternal: handleGlSelectClose,
    searchPlaceholder: 'Search account by name or number',
    onChange: e => {
      handleGlCodeChange('adminFeeGlAccountExternalId', e.target.value);
    },
    value: (_store$homeDashboardS103 = store.homeDashboardStore.getCurrentCompany.selectedPropertyDetails()) === null || _store$homeDashboardS103 === void 0 || (_store$homeDashboardS103 = _store$homeDashboardS103.details) === null || _store$homeDashboardS103 === void 0 || (_store$homeDashboardS103 = _store$homeDashboardS103.glCodeSetup) === null || _store$homeDashboardS103 === void 0 ? void 0 : _store$homeDashboardS103.adminFeeGlAccountExternalId,
    renderValue: selected => {
      var _store$homeDashboardS104;
      if (selected.length === 0) {
        return '';
      }
      return (_store$homeDashboardS104 = store.homeDashboardStore.getCurrentCompany.selectedPropertyDetails()) === null || _store$homeDashboardS104 === void 0 || (_store$homeDashboardS104 = _store$homeDashboardS104.details) === null || _store$homeDashboardS104 === void 0 || (_store$homeDashboardS104 = _store$homeDashboardS104.glCodeSetup) === null || _store$homeDashboardS104 === void 0 || (_store$homeDashboardS104 = _store$homeDashboardS104.glAccountsStored.find(item => item.externalId === selected)) === null || _store$homeDashboardS104 === void 0 ? void 0 : _store$homeDashboardS104.name;
    }
  }, (_store$homeDashboardS105 = store.homeDashboardStore.getCurrentCompany.selectedPropertyDetails()) === null || _store$homeDashboardS105 === void 0 || (_store$homeDashboardS105 = _store$homeDashboardS105.details) === null || _store$homeDashboardS105 === void 0 || (_store$homeDashboardS105 = _store$homeDashboardS105.glCodeSetup) === null || _store$homeDashboardS105 === void 0 ? void 0 : _store$homeDashboardS105.glAccounts.map(i => /*#__PURE__*/React.createElement(MenuItem, {
    value: i.externalId,
    className: classes.glAccountItem
  }, /*#__PURE__*/React.createElement("span", null, i.name), /*#__PURE__*/React.createElement("i", null, "number: ", i.number))))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.allocationBodyDetailedWrapperContentItemSubTitle
  }, "Default GL account"), ((_store$credentials$pa3 = store.credentials.patchAppfolioPropertiesAsync) === null || _store$credentials$pa3 === void 0 || (_store$credentials$pa3 = _store$credentials$pa3.inProgressUnicIds) === null || _store$credentials$pa3 === void 0 ? void 0 : _store$credentials$pa3.includes('glAccountExternalId')) && /*#__PURE__*/React.createElement(Skeleton, {
    variant: "text",
    animation: "wave",
    height: 48,
    width: '100%'
  }), !((_store$credentials$pa4 = store.credentials.patchAppfolioPropertiesAsync) !== null && _store$credentials$pa4 !== void 0 && (_store$credentials$pa4 = _store$credentials$pa4.inProgressUnicIds) !== null && _store$credentials$pa4 !== void 0 && _store$credentials$pa4.includes('glAccountExternalId')) && /*#__PURE__*/React.createElement(SelectMenu, {
    enableSearch: true,
    id: "default-gl-selector",
    labelId: "default-gl-selector-label",
    label: (_store$homeDashboardS106 = store.homeDashboardStore.getCurrentCompany.selectedPropertyDetails()) !== null && _store$homeDashboardS106 !== void 0 && (_store$homeDashboardS106 = _store$homeDashboardS106.details) !== null && _store$homeDashboardS106 !== void 0 && (_store$homeDashboardS106 = _store$homeDashboardS106.glCodeSetup) !== null && _store$homeDashboardS106 !== void 0 && _store$homeDashboardS106.glAccountExternalId ? null : 'Select default GL account',
    disabled: ((_store$homeDashboardS107 = store.homeDashboardStore.getCurrentCompany.selectedPropertyDetails()) === null || _store$homeDashboardS107 === void 0 || (_store$homeDashboardS107 = _store$homeDashboardS107.details) === null || _store$homeDashboardS107 === void 0 || (_store$homeDashboardS107 = _store$homeDashboardS107.glCodeSetup) === null || _store$homeDashboardS107 === void 0 ? void 0 : _store$homeDashboardS107.glAccountsStored.length) === 0,
    onSearch: handleGlSearch,
    onCloseExternal: handleGlSelectClose,
    searchPlaceholder: 'Search account by name or number',
    onChange: e => {
      handleGlCodeChange('glAccountExternalId', e.target.value);
    },
    value: (_store$homeDashboardS108 = store.homeDashboardStore.getCurrentCompany.selectedPropertyDetails()) === null || _store$homeDashboardS108 === void 0 || (_store$homeDashboardS108 = _store$homeDashboardS108.details) === null || _store$homeDashboardS108 === void 0 || (_store$homeDashboardS108 = _store$homeDashboardS108.glCodeSetup) === null || _store$homeDashboardS108 === void 0 ? void 0 : _store$homeDashboardS108.glAccountExternalId,
    renderValue: selected => {
      var _store$homeDashboardS109;
      if (selected.length === 0) {
        return '';
      }
      return (_store$homeDashboardS109 = store.homeDashboardStore.getCurrentCompany.selectedPropertyDetails()) === null || _store$homeDashboardS109 === void 0 || (_store$homeDashboardS109 = _store$homeDashboardS109.details) === null || _store$homeDashboardS109 === void 0 || (_store$homeDashboardS109 = _store$homeDashboardS109.glCodeSetup) === null || _store$homeDashboardS109 === void 0 || (_store$homeDashboardS109 = _store$homeDashboardS109.glAccountsStored.find(item => item.externalId === selected)) === null || _store$homeDashboardS109 === void 0 ? void 0 : _store$homeDashboardS109.name;
    }
  }, (_store$homeDashboardS110 = store.homeDashboardStore.getCurrentCompany.selectedPropertyDetails()) === null || _store$homeDashboardS110 === void 0 || (_store$homeDashboardS110 = _store$homeDashboardS110.details) === null || _store$homeDashboardS110 === void 0 || (_store$homeDashboardS110 = _store$homeDashboardS110.glCodeSetup) === null || _store$homeDashboardS110 === void 0 ? void 0 : _store$homeDashboardS110.glAccounts.map(i => /*#__PURE__*/React.createElement(MenuItem, {
    value: i.externalId,
    className: classes.glAccountItem
  }, /*#__PURE__*/React.createElement("span", null, i.name), /*#__PURE__*/React.createElement("i", null, "number: ", i.number))))), store.account.featureFlagsStore.getIsAppfolioPaperStatementFeeEnabled && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.allocationBodyDetailedWrapperContentItemSubTitle
  }, "Paper statement GL code"), ((_store$credentials$pa5 = store.credentials.patchAppfolioPropertiesAsync) === null || _store$credentials$pa5 === void 0 || (_store$credentials$pa5 = _store$credentials$pa5.inProgressUnicIds) === null || _store$credentials$pa5 === void 0 ? void 0 : _store$credentials$pa5.includes('paperStatementFeeGlAccountExternalId')) && /*#__PURE__*/React.createElement(Skeleton, {
    variant: "text",
    animation: "wave",
    height: 48,
    width: '100%'
  }), !((_store$credentials$pa6 = store.credentials.patchAppfolioPropertiesAsync) !== null && _store$credentials$pa6 !== void 0 && (_store$credentials$pa6 = _store$credentials$pa6.inProgressUnicIds) !== null && _store$credentials$pa6 !== void 0 && _store$credentials$pa6.includes('paperStatementFeeGlAccountExternalId')) && /*#__PURE__*/React.createElement(SelectMenu, {
    enableSearch: true,
    id: "paper-statement-fee-gl-selector",
    labelId: "paper-statement-fee-gl-gl-selector-label",
    label: (_store$homeDashboardS111 = store.homeDashboardStore.getCurrentCompany.selectedPropertyDetails()) !== null && _store$homeDashboardS111 !== void 0 && (_store$homeDashboardS111 = _store$homeDashboardS111.details) !== null && _store$homeDashboardS111 !== void 0 && (_store$homeDashboardS111 = _store$homeDashboardS111.glCodeSetup) !== null && _store$homeDashboardS111 !== void 0 && _store$homeDashboardS111.paperStatementFeeGlAccountExternalId ? null : 'Select paper statement GL code',
    disabled: ((_store$homeDashboardS112 = store.homeDashboardStore.getCurrentCompany.selectedPropertyDetails()) === null || _store$homeDashboardS112 === void 0 || (_store$homeDashboardS112 = _store$homeDashboardS112.details) === null || _store$homeDashboardS112 === void 0 || (_store$homeDashboardS112 = _store$homeDashboardS112.glCodeSetup) === null || _store$homeDashboardS112 === void 0 ? void 0 : _store$homeDashboardS112.glAccountsStored.length) === 0,
    onSearch: handleGlSearch,
    onCloseExternal: handleGlSelectClose,
    searchPlaceholder: 'Search account by name or number',
    onChange: e => {
      if (!(companyData !== null && companyData !== void 0 && companyData.addressId)) {
        setShowCompanyAddressForm(true);
        setPaperStatementGl({
          type: 'paperStatementFeeGlAccountExternalId',
          value: e.target.value
        });
        toast('info', {
          body: ['Please enter your company address first to enable Paper Statements.']
        });
        return;
      }
      handleGlCodeChange('paperStatementFeeGlAccountExternalId', e.target.value);
    },
    value: (_store$homeDashboardS113 = store.homeDashboardStore.getCurrentCompany.selectedPropertyDetails()) === null || _store$homeDashboardS113 === void 0 || (_store$homeDashboardS113 = _store$homeDashboardS113.details) === null || _store$homeDashboardS113 === void 0 || (_store$homeDashboardS113 = _store$homeDashboardS113.glCodeSetup) === null || _store$homeDashboardS113 === void 0 ? void 0 : _store$homeDashboardS113.paperStatementFeeGlAccountExternalId,
    renderValue: selected => {
      var _store$homeDashboardS114;
      if (selected.length === 0) {
        return '';
      }
      return (_store$homeDashboardS114 = store.homeDashboardStore.getCurrentCompany.selectedPropertyDetails()) === null || _store$homeDashboardS114 === void 0 || (_store$homeDashboardS114 = _store$homeDashboardS114.details) === null || _store$homeDashboardS114 === void 0 || (_store$homeDashboardS114 = _store$homeDashboardS114.glCodeSetup) === null || _store$homeDashboardS114 === void 0 || (_store$homeDashboardS114 = _store$homeDashboardS114.glAccountsStored.find(item => item.externalId === selected)) === null || _store$homeDashboardS114 === void 0 ? void 0 : _store$homeDashboardS114.name;
    }
  }, (_store$homeDashboardS115 = store.homeDashboardStore.getCurrentCompany.selectedPropertyDetails()) === null || _store$homeDashboardS115 === void 0 || (_store$homeDashboardS115 = _store$homeDashboardS115.details) === null || _store$homeDashboardS115 === void 0 || (_store$homeDashboardS115 = _store$homeDashboardS115.glCodeSetup) === null || _store$homeDashboardS115 === void 0 ? void 0 : _store$homeDashboardS115.glAccounts.map(i => /*#__PURE__*/React.createElement(MenuItem, {
    value: i.externalId,
    className: classes.glAccountItem
  }, /*#__PURE__*/React.createElement("span", null, i.name), /*#__PURE__*/React.createElement("i", null, "number: ", i.number)))), showCompanyAddressForm && !(companyData !== null && companyData !== void 0 && companyData.addressId) && /*#__PURE__*/React.createElement("div", {
    className: classes.xsSection,
    style: {
      paddingTop: '8px'
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.allocationBodyDetailedWrapperContentItemSubTitle
  }, "Please enter and save your company address first to enable Paper Statements"), /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'row'
    }
  }, /*#__PURE__*/React.createElement(DetailedStreetFinder, {
    name: "postalAddress",
    defaultPropertyAddress: {},
    disabled: store.company.updateCompanyAsync.inProgress,
    _serviceVariableValidate: handleStartValidate,
    _serviceStopValidate: () => setHandleStartValidate(false),
    _serviceStartSubmitting: handleStartSubmitting,
    _serviceEndSubmitting: handleEndSubmitting
  }), /*#__PURE__*/React.createElement("div", {
    className: classes.saveCompanyAddressButton
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "actionButtonInvert",
    onClick: submitForm,
    'custom-attribute': '856-new-billing-module'
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "success"
  })), /*#__PURE__*/React.createElement(ExpandedTooltip, {
    placement: "top",
    title: t('Enter your company address details and press save button to enable Paper Statements.'),
    type: "grey"
  }, /*#__PURE__*/React.createElement(IconButton, null, /*#__PURE__*/React.createElement(Icon, {
    state: "info",
    type: "question"
  }))))))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React.createElement(FormGroup, {
    className: classes.glAccountSwitchWrapper
  }, /*#__PURE__*/React.createElement(FormControlLabel, {
    disabled: (_store$credentials$pa7 = store.credentials.patchAppfolioPropertiesAsync) === null || _store$credentials$pa7 === void 0 || (_store$credentials$pa7 = _store$credentials$pa7.inProgressUnicIds) === null || _store$credentials$pa7 === void 0 ? void 0 : _store$credentials$pa7.includes('rentGlAccountExternalId'),
    control: /*#__PURE__*/React.createElement(Switch, {
      checked: showRentGl,
      onChange: () => handleRentGlSwitch()
    }),
    label: /*#__PURE__*/React.createElement("b", {
      className: classes.glAccountSwitch
    }, "Process rent")
  })), showRentGl && /*#__PURE__*/React.createElement(React.Fragment, null, ((_store$credentials$pa8 = store.credentials.patchAppfolioPropertiesAsync) === null || _store$credentials$pa8 === void 0 || (_store$credentials$pa8 = _store$credentials$pa8.inProgressUnicIds) === null || _store$credentials$pa8 === void 0 ? void 0 : _store$credentials$pa8.includes('rentGlAccountExternalId')) && /*#__PURE__*/React.createElement(Skeleton, {
    variant: "text",
    animation: "wave",
    height: 48,
    width: '100%'
  }), !((_store$credentials$pa9 = store.credentials.patchAppfolioPropertiesAsync) !== null && _store$credentials$pa9 !== void 0 && (_store$credentials$pa9 = _store$credentials$pa9.inProgressUnicIds) !== null && _store$credentials$pa9 !== void 0 && _store$credentials$pa9.includes('rentGlAccountExternalId')) && /*#__PURE__*/React.createElement(SelectMenu, {
    enableSearch: true,
    id: "rent-gl-selector",
    label: (_store$homeDashboardS116 = store.homeDashboardStore.getCurrentCompany.selectedPropertyDetails()) !== null && _store$homeDashboardS116 !== void 0 && (_store$homeDashboardS116 = _store$homeDashboardS116.details) !== null && _store$homeDashboardS116 !== void 0 && (_store$homeDashboardS116 = _store$homeDashboardS116.glCodeSetup) !== null && _store$homeDashboardS116 !== void 0 && _store$homeDashboardS116.rentGlAccountExternalId ? null : 'Select rent GL account',
    labelId: "rent-gl-selector-label",
    disabled: ((_store$homeDashboardS117 = store.homeDashboardStore.getCurrentCompany.selectedPropertyDetails()) === null || _store$homeDashboardS117 === void 0 || (_store$homeDashboardS117 = _store$homeDashboardS117.details) === null || _store$homeDashboardS117 === void 0 || (_store$homeDashboardS117 = _store$homeDashboardS117.glCodeSetup) === null || _store$homeDashboardS117 === void 0 ? void 0 : _store$homeDashboardS117.glAccountsStored.length) === 0,
    onSearch: handleGlSearch,
    onCloseExternal: handleGlSelectClose,
    searchPlaceholder: 'Search account by name or number',
    onChange: e => {
      handleGlCodeChange('rentGlAccountExternalId', e.target.value);
    },
    value: (_store$homeDashboardS118 = store.homeDashboardStore.getCurrentCompany.selectedPropertyDetails()) === null || _store$homeDashboardS118 === void 0 || (_store$homeDashboardS118 = _store$homeDashboardS118.details) === null || _store$homeDashboardS118 === void 0 || (_store$homeDashboardS118 = _store$homeDashboardS118.glCodeSetup) === null || _store$homeDashboardS118 === void 0 ? void 0 : _store$homeDashboardS118.rentGlAccountExternalId,
    renderValue: selected => {
      var _store$homeDashboardS119;
      if (selected.length === 0) {
        return '';
      }
      return (_store$homeDashboardS119 = store.homeDashboardStore.getCurrentCompany.selectedPropertyDetails()) === null || _store$homeDashboardS119 === void 0 || (_store$homeDashboardS119 = _store$homeDashboardS119.details) === null || _store$homeDashboardS119 === void 0 || (_store$homeDashboardS119 = _store$homeDashboardS119.glCodeSetup) === null || _store$homeDashboardS119 === void 0 || (_store$homeDashboardS119 = _store$homeDashboardS119.glAccountsStored.find(item => item.externalId === selected)) === null || _store$homeDashboardS119 === void 0 ? void 0 : _store$homeDashboardS119.name;
    }
  }, (_store$homeDashboardS120 = store.homeDashboardStore.getCurrentCompany.selectedPropertyDetails()) === null || _store$homeDashboardS120 === void 0 || (_store$homeDashboardS120 = _store$homeDashboardS120.details) === null || _store$homeDashboardS120 === void 0 || (_store$homeDashboardS120 = _store$homeDashboardS120.glCodeSetup) === null || _store$homeDashboardS120 === void 0 ? void 0 : _store$homeDashboardS120.glAccounts.map(i => /*#__PURE__*/React.createElement(MenuItem, {
    value: i.externalId,
    className: classes.glAccountItem
  }, /*#__PURE__*/React.createElement("span", null, i.name), /*#__PURE__*/React.createElement("i", null, "number: ", i.number))))))), /*#__PURE__*/React.createElement(Grid, {
    container: true,
    xs: 6
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'column',
      width: '100%'
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.allocationBodyDetailedWrapperContentItemTitle,
    style: {
      paddingTop: '8px'
    }
  }, "Charge on date", /*#__PURE__*/React.createElement(Typography, {
    variant: "body2",
    color: "light"
  }, t('Select the day each month you’d like us to post transactions.'))), ((_store$credentials$pa0 = store.credentials.patchAppfolioPropertiesAsync) === null || _store$credentials$pa0 === void 0 || (_store$credentials$pa0 = _store$credentials$pa0.inProgressUnicIds) === null || _store$credentials$pa0 === void 0 ? void 0 : _store$credentials$pa0.includes('chargeOnDayOfMonth')) && /*#__PURE__*/React.createElement(Skeleton, {
    variant: "text",
    animation: "wave",
    height: 48,
    width: '100%'
  }), !((_store$credentials$pa1 = store.credentials.patchAppfolioPropertiesAsync) !== null && _store$credentials$pa1 !== void 0 && (_store$credentials$pa1 = _store$credentials$pa1.inProgressUnicIds) !== null && _store$credentials$pa1 !== void 0 && _store$credentials$pa1.includes('chargeOnDayOfMonth')) && /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'row'
    }
  }, /*#__PURE__*/React.createElement(SelectMenu, {
    id: "chargeOnDayOfMonth-day-number-selector",
    key: "chargeOnDayOfMonth-day-number-selector-".concat((_store$homeDashboardS121 = store.homeDashboardStore.getCurrentCompany.selectedPropertyDetails()) === null || _store$homeDashboardS121 === void 0 || (_store$homeDashboardS121 = _store$homeDashboardS121.details) === null || _store$homeDashboardS121 === void 0 || (_store$homeDashboardS121 = _store$homeDashboardS121.glCodeSetup) === null || _store$homeDashboardS121 === void 0 ? void 0 : _store$homeDashboardS121.chargeOnDayOfMonth),
    value: (_store$homeDashboardS122 = store.homeDashboardStore.getCurrentCompany.selectedPropertyDetails()) === null || _store$homeDashboardS122 === void 0 || (_store$homeDashboardS122 = _store$homeDashboardS122.details) === null || _store$homeDashboardS122 === void 0 || (_store$homeDashboardS122 = _store$homeDashboardS122.glCodeSetup) === null || _store$homeDashboardS122 === void 0 ? void 0 : _store$homeDashboardS122.chargeOnDayOfMonth,
    label: "Day of the month to charge",
    onChange: event => handleGlCodeChange('chargeOnDayOfMonth', event.target.value),
    'custom-attribute': '857-new-billing-module'
  }, Array.from({
    length: 28
  }, (_, i) => {
    const value = i + 1;
    return /*#__PURE__*/React.createElement(MenuItem, {
      key: value,
      value: value
    }, value);
  })), /*#__PURE__*/React.createElement("div", {
    className: classes.removeChargeOnDateButton
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "actionButtonInvert",
    onClick: () => {
      handleGlCodeChange('chargeOnDayOfMonth', null);
    },
    'custom-attribute': '856-new-billing-module'
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "close"
  })), /*#__PURE__*/React.createElement(ExpandedTooltip, {
    placement: "top",
    title: t('Set the date to post the charge or credit — if you leave it blank, we’ll use today’s date.'),
    type: "grey"
  }, /*#__PURE__*/React.createElement(IconButton, null, /*#__PURE__*/React.createElement(Icon, {
    state: "info",
    type: "question"
  }))))))))), /*#__PURE__*/React.createElement("div", {
    className: classes.allocationBodyDetailedWrapperContentItems
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.allocationBodyDetailedWrapperContentItem
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.allocationBodyDetailedWrapperContentItemTitle
  }, "Payment information"), /*#__PURE__*/React.createElement("div", {
    className: classes.allocationBodyDetailedWrapperContentItemBody
  }, (store.payment.getPaymentMethodsV2Async.inProgress || store.payment.getPropertyPaymentMethodAsync.inProgress || store.payment.setPropertyPaymentMethodAsync.inProgress) && /*#__PURE__*/React.createElement(Skeleton, {
    variant: "text",
    animation: "wave",
    height: 48,
    width: '100%'
  }), !(store.payment.getPaymentMethodsV2Async.inProgress || store.payment.getPropertyPaymentMethodAsync.inProgress || store.payment.setPropertyPaymentMethodAsync.inProgress) && ((_store$homeDashboardS123 = store.homeDashboardStore.getCurrentCompany.selectedPropertyDetails()) === null || _store$homeDashboardS123 === void 0 ? void 0 : _store$homeDashboardS123.details.paymentSetup.paymentMethodsValues.length) > 0 && /*#__PURE__*/React.createElement("div", {
    className: classes.selectWrapper
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.selectIcon
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "wallet"
  })), /*#__PURE__*/React.createElement("div", {
    className: classes.selectContent
  }, /*#__PURE__*/React.createElement(SelectMenu, {
    id: "payment-method-selector",
    value: (_store$homeDashboardS124 = store.homeDashboardStore.getCurrentCompany.selectedPropertyDetails()) === null || _store$homeDashboardS124 === void 0 ? void 0 : _store$homeDashboardS124.details.paymentSetup.propertyPaymentMethod,
    labelId: "payment-method-selector-label",
    onChange: handlePaymentMethodChange,
    onSearch: value => {
      setPaymentMethodSearch(value);
    },
    enableSearch: true,
    handleClose: handleClosePaymentMethodSelect,
    handleOpen: handleOpenPaymentMethodSelect,
    isOpen: isPaymentMethodSelectOpen,
    enableAddAction: true,
    addActionButton: /*#__PURE__*/React.createElement(Button, {
      variant: "menuAction",
      onClick: () => {
        handleClosePaymentMethodSelect();
        handleOpenPaymentMethodModal();
      },
      'custom-attribute': '579-new-billing-module'
    }, /*#__PURE__*/React.createElement(Icon, {
      type: "plus-circle"
    }), "Add new payment method")
  }, (_store$homeDashboardS125 = store.homeDashboardStore.getCurrentCompany.selectedPropertyDetails()) === null || _store$homeDashboardS125 === void 0 ? void 0 : _store$homeDashboardS125.details.paymentSetup.paymentMethodsValues.map(method => {
    var _store$homeDashboardS126, _store$homeDashboardS127;
    if (method.isDefault && !((_store$homeDashboardS126 = store.homeDashboardStore.getCurrentCompany.selectedPropertyDetails()) !== null && _store$homeDashboardS126 !== void 0 && _store$homeDashboardS126.details.paymentSetup.propertyPaymentMethod) || method.id === ((_store$homeDashboardS127 = store.homeDashboardStore.getCurrentCompany.selectedPropertyDetails()) === null || _store$homeDashboardS127 === void 0 ? void 0 : _store$homeDashboardS127.details.paymentSetup.propertyPaymentMethod)) {
      return /*#__PURE__*/React.createElement(MenuItem, {
        value: method.id,
        key: method.id
      }, capitalizeFirstLetter(method.brand), " ending in \u2022\u2022\u2022\u2022", ' ', method.last4);
    }
  }), (_store$homeDashboardS128 = store.homeDashboardStore.getCurrentCompany.selectedPropertyDetails()) === null || _store$homeDashboardS128 === void 0 ? void 0 : _store$homeDashboardS128.details.paymentSetup.paymentMethodsValues.map(method => {
    var _store$homeDashboardS129, _store$homeDashboardS130;
    if (!(method.isDefault && !((_store$homeDashboardS129 = store.homeDashboardStore.getCurrentCompany.selectedPropertyDetails()) !== null && _store$homeDashboardS129 !== void 0 && _store$homeDashboardS129.details.paymentSetup.propertyPaymentMethod) || method.id === ((_store$homeDashboardS130 = store.homeDashboardStore.getCurrentCompany.selectedPropertyDetails()) === null || _store$homeDashboardS130 === void 0 ? void 0 : _store$homeDashboardS130.details.paymentSetup.propertyPaymentMethod)) && (paymentMethodSearch === '' || "".concat(method.brand, " ending in \u2022\u2022\u2022\u2022 ").concat(method.last4).toLocaleLowerCase().includes(paymentMethodSearch.toLocaleLowerCase()))) {
      return /*#__PURE__*/React.createElement(MenuItem, {
        value: method.id,
        key: method.id
      }, capitalizeFirstLetter(method.brand), " ending in \u2022\u2022\u2022\u2022", ' ', method.last4);
    }
  }))))), !(store.payment.getPaymentMethodsV2Async.inProgress || store.payment.getPropertyPaymentMethodAsync.inProgress || store.payment.setPropertyPaymentMethodAsync.inProgress) && ((_store$homeDashboardS131 = store.homeDashboardStore.getCurrentCompany.selectedPropertyDetails()) === null || _store$homeDashboardS131 === void 0 ? void 0 : _store$homeDashboardS131.details.paymentSetup.paymentMethodsValues.length) === 0 && /*#__PURE__*/React.createElement("div", {
    className: classes.allocationBodyDetailedWrapperContentItemAction
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "actionButtonInvert",
    onClick: () => {
      handleClosePaymentMethodSelect();
      handleOpenPaymentMethodModal();
    },
    'custom-attribute': '580-new-billing-module'
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "plus"
  }), /*#__PURE__*/React.createElement("span", null, t('subscriptions.add_new_payment_method'))))), !store.company.companyFeatureStore.isAppfolio && /*#__PURE__*/React.createElement("div", {
    className: classes.allocationBodyDetailedWrapperContentItem
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.allocationBodyDetailedWrapperContentItemTitle
  }, t('add_new_property_flow.reimbursement_details')), /*#__PURE__*/React.createElement("div", {
    className: classes.allocationBodyDetailedWrapperContentItemBody
  }, getPropertyReimbursementLoadingStatus((_store$homeDashboardS132 = store.homeDashboardStore.getCurrentProperty) === null || _store$homeDashboardS132 === void 0 ? void 0 : _store$homeDashboardS132.id) ? /*#__PURE__*/React.createElement(Skeleton, {
    variant: "text",
    animation: "wave",
    height: 48,
    width: '100%'
  }) : /*#__PURE__*/React.createElement("div", {
    className: classes.selectWrapper
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.allocationBodyDetailedWrapperContentItemAction
  }, ((_store$homeDashboardS133 = store.homeDashboardStore.getCurrentCompany) === null || _store$homeDashboardS133 === void 0 ? void 0 : _store$homeDashboardS133.companyReimbursementMethods) === null && !((_store$homeDashboardS134 = store.homeDashboardStore.getCurrentCompany) !== null && _store$homeDashboardS134 !== void 0 && (_store$homeDashboardS134 = _store$homeDashboardS134.companyReimbursementMethods) !== null && _store$homeDashboardS134 !== void 0 && _store$homeDashboardS134.length) ? /*#__PURE__*/React.createElement(Button, {
    variant: "actionButtonInvert",
    onClick: () => {
      handleCloseReimbursementSelect();
      handleOpenReimbursementModal();
    },
    'custom-attribute': '581-new-billing-module'
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "plus"
  }), "Add new reimbursement information") : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: classes.selectIcon
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "credit-card"
  })), /*#__PURE__*/React.createElement("div", {
    className: classes.selectContent
  }, /*#__PURE__*/React.createElement(SelectMenu, {
    id: "reimbursement-method-selector",
    value: store.homeDashboardStore.getCurrentCompany.getPropertyReimbursementMethods((_store$homeDashboardS135 = store.homeDashboardStore.getCurrentProperty) === null || _store$homeDashboardS135 === void 0 ? void 0 : _store$homeDashboardS135.id),
    labelId: "reimbursement-selector-label",
    label: store.homeDashboardStore.getCurrentCompany.getPropertyReimbursementMethods((_store$homeDashboardS136 = store.homeDashboardStore.getCurrentProperty) === null || _store$homeDashboardS136 === void 0 ? void 0 : _store$homeDashboardS136.id) === null ? t('Select the method you want to use by default. (Optional)') : '',
    onChange: handleReimbursementChange,
    enableAddAction: true,
    enableSearch: true,
    onSearch: key => setReimbursementMethodSearchKey(key),
    handleClose: handleCloseReimbursementSelect,
    handleOpen: handleOpenReimbursementSelect,
    isOpen: isReimbursementSelectOpen,
    addActionButton: /*#__PURE__*/React.createElement(Button, {
      variant: "menuAction",
      onClick: () => {
        handleCloseReimbursementSelect();
        handleOpenReimbursementModal();
      },
      'custom-attribute': '582-new-billing-module'
    }, /*#__PURE__*/React.createElement(Icon, {
      type: "plus-circle"
    }), "Add new reimbursement information"),
    renderValue: () => {
      var _store$homeDashboardS137;
      const currentReimbursementMethod = store.homeDashboardStore.getCurrentCompany.getPropertyReimbursementMethods((_store$homeDashboardS137 = store.homeDashboardStore.getCurrentProperty) === null || _store$homeDashboardS137 === void 0 ? void 0 : _store$homeDashboardS137.id);
      if (currentReimbursementMethod === null) {
        return '';
      } else {
        if (currentReimbursementMethod.methodType === PAYMENT_METHODS.ACH) {
          return "".concat(currentReimbursementMethod === null || currentReimbursementMethod === void 0 ? void 0 : currentReimbursementMethod.nameOnAccount, " ").concat(currentReimbursementMethod !== null && currentReimbursementMethod !== void 0 && currentReimbursementMethod.depositoryName ? "(".concat(currentReimbursementMethod.depositoryName, ")") : '');
        } else if (currentReimbursementMethod.methodType === PAYMENT_METHODS.RegularCheck) {
          return 'Check';
        }
      }
    }
  }, getReimbursementMethodsList())))))))), /*#__PURE__*/React.createElement("div", {
    className: classes.allocationBodyDetailedWrapperContentItems
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.allocationBodyDetailedWrapperContentItem
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.allocationBodyDetailedWrapperContentItemTitle
  }, t('add_new_property_flow.property_information')), /*#__PURE__*/React.createElement("div", {
    className: classes.allocationBodyDetailedWrapperContentItemBody
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.detailsListBox
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.detailsListBoxContent
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.detailsListBoxIcon
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "building"
  })), /*#__PURE__*/React.createElement("div", {
    className: classes.detailsListBoxData
  }, /*#__PURE__*/React.createElement("table", null, /*#__PURE__*/React.createElement("tbody", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", null, t('general.address'), ":"), /*#__PURE__*/React.createElement("td", null, getPropertyInformationLoadingStatus(store.homeDashboardStore.selectedPropertyId) ? /*#__PURE__*/React.createElement(Skeleton, {
    variant: "text",
    animation: "wave",
    height: 24,
    width: 300
  }) : (_store$homeDashboardS138 = store.homeDashboardStore.getCurrentProperty) === null || _store$homeDashboardS138 === void 0 || (_store$homeDashboardS138 = _store$homeDashboardS138.propertyInformation) === null || _store$homeDashboardS138 === void 0 || (_store$homeDashboardS138 = _store$homeDashboardS138.address) === null || _store$homeDashboardS138 === void 0 ? void 0 : _store$homeDashboardS138.addressString)), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", null, "Owner:"), /*#__PURE__*/React.createElement("td", null, getPropertyInformationLoadingStatus(store.homeDashboardStore.selectedPropertyId) ? /*#__PURE__*/React.createElement(Skeleton, {
    variant: "text",
    animation: "wave",
    height: 24,
    width: 300
  }) : (_store$homeDashboardS139 = store.homeDashboardStore.getCurrentProperty) === null || _store$homeDashboardS139 === void 0 || (_store$homeDashboardS139 = _store$homeDashboardS139.propertyInformation) === null || _store$homeDashboardS139 === void 0 ? void 0 : _store$homeDashboardS139.ownership)), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", null, "Sq. ft.:"), /*#__PURE__*/React.createElement("td", null, getPropertyInformationLoadingStatus(store.homeDashboardStore.selectedPropertyId) ? /*#__PURE__*/React.createElement(Skeleton, {
    variant: "text",
    animation: "wave",
    height: 24,
    width: 300
  }) : ((_store$homeDashboardS140 = store.homeDashboardStore.getCurrentProperty) === null || _store$homeDashboardS140 === void 0 ? void 0 : _store$homeDashboardS140.propertyBuildingSquare) || t('general.not_set')))))), !store.company.companyFeatureStore.isAppfolio && /*#__PURE__*/React.createElement("div", {
    className: classes.detailsListBoxEdit
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "actionIcon",
    size: "small",
    onClick: () => handleOpenPropertyInfoModal(),
    'custom-attribute': '583-new-billing-module'
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "edit"
  }))))))), /*#__PURE__*/React.createElement("div", {
    className: classes.allocationBodyDetailedWrapperContentItem
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.allocationBodyDetailedWrapperContentItemTitle
  }, t('add_new_property_flow.contact_information')), /*#__PURE__*/React.createElement("div", {
    className: classes.allocationBodyDetailedWrapperContentItemBody
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.detailsListBox
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.detailsListBoxContent
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.detailsListBoxIcon
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "account-box"
  })), /*#__PURE__*/React.createElement("div", {
    className: classes.detailsListBoxData
  }, /*#__PURE__*/React.createElement("table", null, /*#__PURE__*/React.createElement("tbody", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", null, t('Primary'), ":"), /*#__PURE__*/React.createElement("td", null, getContactInformationLoadingStatus(store.homeDashboardStore.selectedPropertyId) ? /*#__PURE__*/React.createElement(Skeleton, {
    variant: "text",
    animation: "wave",
    height: 24,
    width: 300
  }) : (_store$homeDashboardS141 = store.homeDashboardStore.getCurrentProperty) === null || _store$homeDashboardS141 === void 0 || (_store$homeDashboardS141 = _store$homeDashboardS141.propertyInformation) === null || _store$homeDashboardS141 === void 0 || (_store$homeDashboardS141 = _store$homeDashboardS141.propertyContacts) === null || _store$homeDashboardS141 === void 0 ? void 0 : _store$homeDashboardS141.filter(pC => pC.contactType === 'Building').map(i => {
    var _store$homeDashboardS142, _store$homeDashboardS143;
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Typography, {
      variant: 'h6'
    }, (_store$homeDashboardS142 = store.homeDashboardStore.getCurrentCompany.companyTeamMemberDetails(i.teamMemberId)) === null || _store$homeDashboardS142 === void 0 ? void 0 : _store$homeDashboardS142.getFullName), /*#__PURE__*/React.createElement(Typography, {
      variant: 'body2'
    }, (_store$homeDashboardS143 = store.homeDashboardStore.getCurrentCompany.companyTeamMemberDetails(i.teamMemberId)) === null || _store$homeDashboardS143 === void 0 ? void 0 : _store$homeDashboardS143.getEmail));
  }))), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", null, "Secondary:"), /*#__PURE__*/React.createElement("td", null, getContactInformationLoadingStatus(store.homeDashboardStore.selectedPropertyId) ? /*#__PURE__*/React.createElement(Skeleton, {
    variant: "text",
    animation: "wave",
    height: 24,
    width: 300
  }) : (_store$homeDashboardS144 = store.homeDashboardStore.getCurrentProperty) === null || _store$homeDashboardS144 === void 0 || (_store$homeDashboardS144 = _store$homeDashboardS144.propertyInformation) === null || _store$homeDashboardS144 === void 0 || (_store$homeDashboardS144 = _store$homeDashboardS144.propertyContacts) === null || _store$homeDashboardS144 === void 0 || (_store$homeDashboardS144 = _store$homeDashboardS144.filter(pC => pC.contactType === 'Utility')) === null || _store$homeDashboardS144 === void 0 ? void 0 : _store$homeDashboardS144.map(i => {
    var _store$homeDashboardS145, _store$homeDashboardS146;
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Typography, {
      variant: 'h6'
    }, ((_store$homeDashboardS145 = store.homeDashboardStore.getCurrentCompany.companyTeamMemberDetails(i.teamMemberId)) === null || _store$homeDashboardS145 === void 0 ? void 0 : _store$homeDashboardS145.getFullName) || i.teamMemberId), /*#__PURE__*/React.createElement(Typography, {
      variant: 'body2'
    }, ((_store$homeDashboardS146 = store.homeDashboardStore.getCurrentCompany.companyTeamMemberDetails(i.teamMemberId)) === null || _store$homeDashboardS146 === void 0 ? void 0 : _store$homeDashboardS146.getEmail) || i.teamMemberId));
  })))))), /*#__PURE__*/React.createElement("div", {
    className: classes.detailsListBoxEdit
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "actionIcon",
    size: "small",
    onClick: () => {
      handleOpenContactInformationModal();
    },
    'custom-attribute': '583-new-billing-module'
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "edit"
  })))))))), /*#__PURE__*/React.createElement("div", {
    className: classes.allocationBodyDetailedWrapperContentItem
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.allocationBodyDetailedWrapperContentItemTitle
  }, "Fees"), /*#__PURE__*/React.createElement("div", {
    className: classes.allocationBodyDetailedWrapperContentItemBody
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    columnSpacing: 8,
    rowSpacing: 8
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.detailsListBox
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.detailsListBoxContent
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.detailsListBoxIcon
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "coins-in-hand"
  })), /*#__PURE__*/React.createElement("div", {
    className: classes.detailsListBoxData
  }, /*#__PURE__*/React.createElement("table", null, /*#__PURE__*/React.createElement("tbody", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", null, "Admin fee:"), /*#__PURE__*/React.createElement("td", null, (_store$homeDashboardS147 = store.homeDashboardStore.getCurrentCompany.selectedPropertyDetails()) !== null && _store$homeDashboardS147 !== void 0 && (_store$homeDashboardS147 = _store$homeDashboardS147.details.feeSetup.getPropertyFee({
    feeName: 'adminFee'
  })) !== null && _store$homeDashboardS147 !== void 0 && _store$homeDashboardS147.value ? "$".concat((_store$homeDashboardS148 = store.homeDashboardStore.getCurrentCompany.selectedPropertyDetails().details.feeSetup.getPropertyFee({
    feeName: 'adminFee'
  })) === null || _store$homeDashboardS148 === void 0 ? void 0 : _store$homeDashboardS148.value) : 'Not set')), !store.company.companyFeatureStore.isAppfolio && /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", null, "Late penalty:"), /*#__PURE__*/React.createElement("td", null, (_store$homeDashboardS149 = store.homeDashboardStore.getCurrentCompany.selectedPropertyDetails()) !== null && _store$homeDashboardS149 !== void 0 && (_store$homeDashboardS149 = _store$homeDashboardS149.details.feeSetup.getPropertyFee({
    feeName: 'lateFee'
  })) !== null && _store$homeDashboardS149 !== void 0 && _store$homeDashboardS149.feeUnitType ? ((_store$homeDashboardS150 = store.homeDashboardStore.getCurrentCompany.selectedPropertyDetails().details.feeSetup.getPropertyFee({
    feeName: 'lateFee'
  })) === null || _store$homeDashboardS150 === void 0 ? void 0 : _store$homeDashboardS150.feeUnitType) === FEE_UNIT_TYPES.percentage ? '' : '$' : '', ((_store$homeDashboardS151 = store.homeDashboardStore.getCurrentCompany.selectedPropertyDetails()) === null || _store$homeDashboardS151 === void 0 || (_store$homeDashboardS151 = _store$homeDashboardS151.details.feeSetup.getPropertyFee({
    feeName: 'lateFee'
  })) === null || _store$homeDashboardS151 === void 0 ? void 0 : _store$homeDashboardS151.value) || 'Not set', (_store$homeDashboardS152 = store.homeDashboardStore.getCurrentCompany.selectedPropertyDetails()) !== null && _store$homeDashboardS152 !== void 0 && (_store$homeDashboardS152 = _store$homeDashboardS152.details.feeSetup.getPropertyFee({
    feeName: 'lateFee'
  })) !== null && _store$homeDashboardS152 !== void 0 && _store$homeDashboardS152.feeUnitType ? ((_store$homeDashboardS153 = store.homeDashboardStore.getCurrentCompany.selectedPropertyDetails()) === null || _store$homeDashboardS153 === void 0 || (_store$homeDashboardS153 = _store$homeDashboardS153.details.feeSetup.getPropertyFee({
    feeName: 'lateFee'
  })) === null || _store$homeDashboardS153 === void 0 ? void 0 : _store$homeDashboardS153.feeUnitType) === FEE_UNIT_TYPES.percentage ? '%' : '' : ''))))), /*#__PURE__*/React.createElement("div", {
    className: classes.detailsListBoxEdit
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "actionIcon",
    size: "small",
    onClick: () => handleOpenFeeSetupModal(),
    'custom-attribute': '584-new-billing-module'
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "edit"
  })))))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.detailsListBox
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.detailsListBoxContent
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.detailsListBoxIcon
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "coins-in-hand"
  })), /*#__PURE__*/React.createElement("div", {
    className: classes.detailsListBoxData
  }, /*#__PURE__*/React.createElement("table", null, /*#__PURE__*/React.createElement("tbody", null, store.payment.stripeProducts.map(product => {
    var _store$homeDashboardS154;
    if (product.name === 'Unit Subscription Fee' || store.company.companyFeatureStore.isAppfolio && product.name === 'Convenience Fee' || (store.company.companyFeatureStore.disablePaperStatementFee || (_store$homeDashboardS154 = store.homeDashboardStore.getCurrentCompany) !== null && _store$homeDashboardS154 !== void 0 && (_store$homeDashboardS154 = _store$homeDashboardS154.companyFeatureSet) !== null && _store$homeDashboardS154 !== void 0 && _store$homeDashboardS154.disablePaperStatementFee) && (product.name === 'Paper Statement' || product.name === 'Paper Invitation')) return;
    return /*#__PURE__*/React.createElement("tr", {
      key: product.name
    }, /*#__PURE__*/React.createElement("td", null, product.name, ":"), /*#__PURE__*/React.createElement("td", null, product.feeUnitType === 'Percentage' ? "".concat(product.defaultAmount, "%") : "$".concat(product.defaultAmount)));
  })))))))))), currentPropertySubscription && /*#__PURE__*/React.createElement("div", {
    className: classes.allocationBodyDetailedWrapperContentItem
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.allocationBodyDetailedWrapperContentItemTitle
  }, "Subscription"), /*#__PURE__*/React.createElement("div", {
    className: classes.allocationBodyDetailedWrapperContentItemBody
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    columnSpacing: 8,
    rowSpacing: 8
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.detailsListBox
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.detailsListBoxContent
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.detailsListBoxIcon
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "auto-pay"
  })), /*#__PURE__*/React.createElement("div", {
    className: classes.detailsListBoxData
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Typography, {
    variant: "h6"
  }, capitalizeFirstLetter(((_currentPropertySubsc = currentPropertySubscription.scope) === null || _currentPropertySubsc === void 0 ? void 0 : _currentPropertySubsc.toLowerCase()) || ''), ' ', "level"), /*#__PURE__*/React.createElement(Typography, {
    variant: "body2",
    color: "light"
  }, "start date:", ' ', moment(currentPropertySubscription.startDate).format('MM/DD/YYYY')))), /*#__PURE__*/React.createElement(Chip, {
    label: capitalizeFirstLetter(((_currentPropertySubsc2 = currentPropertySubscription.status) === null || _currentPropertySubsc2 === void 0 ? void 0 : _currentPropertySubsc2.toLowerCase()) || ''),
    size: "small",
    variant: ((_currentPropertySubsc3 = currentPropertySubscription.status) === null || _currentPropertySubsc3 === void 0 ? void 0 : _currentPropertySubsc3.toLowerCase()) === 'active' ? 'success' : 'inactive',
    className: classes.subscriptionChip
  }))))))), /*#__PURE__*/React.createElement("div", {
    className: classes.allocationBodyDetailedWrapperContentItem
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.allocationBodyDetailedWrapperContentItemTitle
  }, "Unit setup"), /*#__PURE__*/React.createElement("div", {
    className: classes.allocationBodyDetailedWrapperContentItemBody
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    columnSpacing: 8,
    rowSpacing: 8
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.detailsListBox
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.detailsListBoxContent
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.detailsListBoxIcon
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "door"
  })), /*#__PURE__*/React.createElement("div", {
    className: classes.detailsListBoxData
  }, /*#__PURE__*/React.createElement("table", null, /*#__PURE__*/React.createElement("tbody", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", null, "Units:"), /*#__PURE__*/React.createElement("td", null, (_store$units$getUnits = store.units.getUnitsAsync.inProgressUnicIds) !== null && _store$units$getUnits !== void 0 && _store$units$getUnits.includes((_store$homeDashboardS155 = store.homeDashboardStore.getCurrentProperty) === null || _store$homeDashboardS155 === void 0 ? void 0 : _store$homeDashboardS155.id) ? /*#__PURE__*/React.createElement(Skeleton, {
    variant: "text",
    animation: "wave",
    height: 24,
    width: 50
  }) : (_store$homeDashboardS156 = store.homeDashboardStore.getCurrentCompany.selectedPropertyDetails()) === null || _store$homeDashboardS156 === void 0 ? void 0 : _store$homeDashboardS156.details.unitSetup.savedUnits.length))))), /*#__PURE__*/React.createElement("div", {
    className: classes.detailsListBoxEdit
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "actionIcon",
    size: "small",
    onClick: () => handleOpenUnitModal(),
    'custom-attribute': '585-new-billing-module'
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "edit"
  })))))))))))), isCurrentPropertyIncompleted && /*#__PURE__*/React.createElement("div", {
    className: classes.newPropertySetupBody
  }, /*#__PURE__*/React.createElement(PropertyAddPage, {
    key: "NBM-PropertyAddPage-".concat(store.homeDashboardStore.selectedPropertyId, "-").concat(store.homeDashboardStore.selectedPortfolioId),
    hideBreadcrumbs: true,
    propertyIdExt: store.homeDashboardStore.selectedPropertyId,
    portfolioIdExt: store.homeDashboardStore.selectedPortfolioId,
    registerActionBack: fn => backActionRef.current = fn,
    registerActionNext: fn => nextActionRef.current = fn
  })))), store.homeDashboardStore.getCurrentCompany.companyDashboardViewType === 'list-view' && store.homeDashboardStore.selectedPropertyId === 'all' && currentTab !== "".concat(basePath, "/details") && /*#__PURE__*/React.createElement(PropertiesListView, {
    handleShowEnrollModal: handleShowEnrollModal,
    handleShowManageAccessModal: handleShowManageAccessModal,
    setIsDeletePortfolioModalOpen: setIsDeletePortfolioModalOpen,
    setDeleteModalProps: setDeleteModalProps,
    setIsRenamePortfolioModalOpen: setIsRenamePortfolioModalOpen,
    setRenameModalProps: setRenameModalProps,
    openPropertyDetails: id => {
      openPropertyDetails(id);
    },
    triggerRefresh: triggerRefreshPortfolioData
  }))))), /*#__PURE__*/React.createElement(SimpleConfirmationModal, {
    key: 'billing_template_removal_confirmation_modal',
    headerText: 'Billing template removal confirmation',
    bodyText: removeTemplateModalBodyText,
    externalIsOpen: removeTemplateModalState,
    callBack: deletePropertyUtilityConfirmationActionHandler,
    objectToPassOver: removeTemplateModalPassoverObject,
    customTrigger: null
  }), /*#__PURE__*/React.createElement(SimpleConfirmationModal, {
    key: 'Amenity_removal_confirmation_modal',
    headerText: 'Amenity removal confirmation',
    bodyText: removeAmenityModalBodyText,
    externalIsOpen: removeAmenityModalState,
    callBack: deleteAmenityConfirmationActionHandler,
    objectToPassOver: removeAmenityModalPassoverObject,
    customTrigger: null
  }), /*#__PURE__*/React.createElement(SimpleConfirmationModal, {
    key: 'Billing-Automation-Setup-Confirmation',
    headerText: t('add_new_property_flow.auto_billing_activation_modal_title'),
    bodyComponent: /*#__PURE__*/React.createElement(BigWarningAlert, null, /*#__PURE__*/React.createElement(Typography, {
      variant: "h4"
    }, t('add_new_property_flow.auto_billing_activation_modal_alert_title')), /*#__PURE__*/React.createElement(Typography, {
      variant: "body1",
      dangerouslySetInnerHTML: {
        __html: DOMPurify.sanitize(t('add_new_property_flow.auto_billing_activation_modal_alert_content'))
      }
    })),
    externalIsOpen: billingAutomationSetupModalStatesDemo === 'activate',
    callBack: _ref0 => {
      let action = _ref0.action,
        objectToPassOver = _ref0.objectToPassOver;
      console.log('Billing-Automation-Setup-Confirmation', {
        action,
        objectToPassOver
      });
      if (action === 'cancel') {
        setBillingAutomationSetupModalStatesDemo('create');
      }
      if (action === 'submit') {
        setBillingAutomationSetupModalStatesDemo('activated');
      }
    },
    objectToPassOver: {
      test: 'Test value'
    },
    customTrigger: null
  }), isAssignPortfoliosToPropertyModalOpen && /*#__PURE__*/React.createElement(AssignPortfoliosToPropertyModal, {
    key: 'AssignPortfoliosToPropertyModalKey',
    externalIsOpen: isAssignPortfoliosToPropertyModalOpen,
    callback: data => {
      if (data.action === 'submit') {
        var _data$data;
        store.portfolios.editPropertyPortfoliosRelationshipAsync.run({
          propertyId: assignPortfoliosToPropertyModalPassoverObject === null || assignPortfoliosToPropertyModalPassoverObject === void 0 ? void 0 : assignPortfoliosToPropertyModalPassoverObject.id,
          portfolioIds: data === null || data === void 0 || (_data$data = data.data) === null || _data$data === void 0 || (_data$data = _data$data.portfolioIds) === null || _data$data === void 0 ? void 0 : _data$data.filter(propertyPortfolioId => {
            var _store$homeDashboardS157;
            return ((_store$homeDashboardS157 = store.homeDashboardStore.getCurrentCompany) === null || _store$homeDashboardS157 === void 0 || (_store$homeDashboardS157 = _store$homeDashboardS157.companyPortfolioDataDetails(propertyPortfolioId)) === null || _store$homeDashboardS157 === void 0 ? void 0 : _store$homeDashboardS157.isDefault) !== true;
          })
        }).then(resp => {
          if (resp !== null && resp !== void 0 && resp.isSuccessful) {
            toast('success', {
              body: ['Successfully updated!']
            });
          }
          triggerRefreshPortfolioData();
        });
      }
      setIsAssignPortfoliosToPropertyModalOpen(false);
      setAssignPortfoliosToPropertyModalPassoverObject(null);
    },
    externalPortfolioList: assignPortfoliosToPropertyModalPassoverObject === null || assignPortfoliosToPropertyModalPassoverObject === void 0 || (_assignPortfoliosToPr = assignPortfoliosToPropertyModalPassoverObject.propertyInformation) === null || _assignPortfoliosToPr === void 0 ? void 0 : _assignPortfoliosToPr.portfolioIds,
    propertyAddress: assignPortfoliosToPropertyModalPassoverObject === null || assignPortfoliosToPropertyModalPassoverObject === void 0 || (_assignPortfoliosToPr2 = assignPortfoliosToPropertyModalPassoverObject.dashboard) === null || _assignPortfoliosToPr2 === void 0 ? void 0 : _assignPortfoliosToPr2.propertyAddress,
    currentProperty: assignPortfoliosToPropertyModalPassoverObject
  }), /*#__PURE__*/React.createElement(AssignPropertiesToPortfolioModal, {
    key: 'AssignPropertiesToPortfolioModalKey',
    externalIsOpen: isAssignPropertiesToPortfolioModalOpen,
    subTitle: (_store$homeDashboardS158 = store.homeDashboardStore.getCurrentPortfolio) === null || _store$homeDashboardS158 === void 0 ? void 0 : _store$homeDashboardS158.name,
    externalPortfolioItem: store.homeDashboardStore.getCurrentPortfolio,
    callback: async data => {
      if (data.action === 'submit') {
        var _store$homeDashboardS159, _store$homeDashboardS160, _store$homeDashboardS161, _store$homeDashboardS162;
        const selectedPropertyIds = data.data.selectedPropertyIds;
        const portfolioId = data.data.portfolioId;
        const companyProperties = (_store$homeDashboardS159 = store.homeDashboardStore.getCurrentCompany) === null || _store$homeDashboardS159 === void 0 ? void 0 : _store$homeDashboardS159.getAllUnicCompanyProperties;
        const promises = [];
        companyProperties.forEach(property => {
          if (property.propertyInformation.portfolioIds.includes(portfolioId)) {
            if (!selectedPropertyIds.includes(property.id)) {
              promises.push({
                propertyId: property.id,
                portfolioIds: [...property.propertyInformation.portfolioIds.filter(i => i !== portfolioId)].filter(v => v != null)
              });
            }
          } else {
            if (selectedPropertyIds.includes(property.id) && !property.propertyInformation.portfolioIds.includes(portfolioId)) {
              promises.push({
                propertyId: property.id,
                portfolioIds: [...property.propertyInformation.portfolioIds, portfolioId].filter(v => v != null)
              });
            }
          }
        });
        let isChainFailed = false;
        for (const promiseElement of promises) {
          if (isChainFailed) {
            toast('error', {
              body: [t('Skipping further updates due to a previous failure')]
            });
            break;
          }
          const reps = await store.portfolios.editPropertyPortfoliosRelationshipAsync.run({
            portfolioIds: promiseElement.portfolioIds,
            propertyId: promiseElement.propertyId
          });
          if (!(reps !== null && reps !== void 0 && reps.isSuccessful)) {
            isChainFailed = true;
          }
        }
        toast('success', {
          body: [t('Successfully updated property portfolio relationship')]
        });
        triggerRefreshPortfolioData();
        const propertyPortfolioSet = (_store$homeDashboardS160 = store.homeDashboardStore.getCurrentCompany) === null || _store$homeDashboardS160 === void 0 ? void 0 : _store$homeDashboardS160.getAllUnicCompanyProperties.map(i => {
          return {
            propertyId: i.id,
            portfolioId: i.propertyPortfolioInfo.id
          };
        }).flat();
        (_store$homeDashboardS161 = store.homeDashboardStore.getCurrentCompany) === null || _store$homeDashboardS161 === void 0 || _store$homeDashboardS161.fetchPropertyInformationBatch(propertyPortfolioSet);
        (_store$homeDashboardS162 = store.homeDashboardStore.getCurrentCompany) === null || _store$homeDashboardS162 === void 0 || _store$homeDashboardS162.fetchBuildingsInformationBatch(propertyPortfolioSet);
      }
      setIsAssignPropertiesToPortfolioModalOpen(false);
    },
    newPropertyCallback: () => {
      setIsIncompletedProperty(true);
      store.homeDashboardStore.selectActivePropertyId(null, false);
      setIsAssignPropertiesToPortfolioModalOpen(false);
    }
  }), isRemoveConfirmationModalOpen && /*#__PURE__*/React.createElement(SimpleConfirmationModal, {
    key: "UnassignPortfolioModal-main-content",
    externalIsOpen: isRemoveConfirmationModalOpen,
    headerText: t('add_new_property_flow.remove_property_from_portfolio_title'),
    subTitleText: (_removePortfolioFromP = removePortfolioFromPropertyModalPassoverObject.payload.dashboard) === null || _removePortfolioFromP === void 0 ? void 0 : _removePortfolioFromP.propertyAddress,
    objectToPassOver: removePortfolioFromPropertyModalPassoverObject,
    callBack: data => {
      setIsRemoveConfirmationModalOpen(false);
      if (data.action === 'submit') {
        removePortfolioActionHandler(removePortfolioFromPropertyModalPassoverObject.payload, removePortfolioFromPropertyModalPassoverObject.portfolioId);
      }
    },
    customSubmitButtonName: t('general.remove'),
    bodyComponent: /*#__PURE__*/React.createElement(BigWarningAlert, null, /*#__PURE__*/React.createElement(Typography, {
      variant: "h4"
    }, t('add_new_property_flow.remove_property_from_portfolio_description', {
      propertyAddress: removePortfolioFromPropertyModalPassoverObject.payload.dashboard.propertyAddress,
      portfolioName: removePortfolioFromPropertyModalPassoverObject.payload.propertyPortfolioInfo.name
    }))),
    customTrigger: null
  })));
});